<template>
  <div>

    <div align="left" style="margin-bottom:20px;float:left;">
      <el-button type="primary" icon="el-icon-upload" size="mini" style="width:230px;"
        @click="dialogUploadExcel = true">社員情報データインポート</el-button>
    </div>
    <div align="right" style="margin-top:20px;margin-bottom:20px;margin-right:130px">
      <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="dialogVisible = true">{{
        $t("general.add") }}
      </el-button>
    </div>

    <el-table @sort-change="changeTableSort" :data="tableData" highlight-current-row border style="width: 100%;"
      :empty-text="$t('general.empty_data')">
      <el-table-column sortable="custom" prop="employee_id" :label="$t('general.employee_id')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empList.name')" align="center">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-button type="text" @click="handleDetails(scope.$index, scope.row)">{{ scope.row.name }}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="employee_type" :label="$t('empList.title')" align="center" width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_type }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empList.gender')" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.gender }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empList.birthday')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.birthday | formatDate }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="begin_date" :label="$t('empList.begin_date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.begin_date | formatDate }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="330px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{ $t("general.edit") }}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDeleteAll(scope.$index, scope.row)">
            {{ $t("general.delete") }}</el-button>
          <el-button size="mini" type="success" icon="el-icon-user" @click="handleFamily(scope.$index, scope.row)">
            {{ $t("empList.family_info") }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- dialog upload excel -->
    <el-dialog title="新規登録する社員情報のファイルを選択してください。 " :visible.sync="dialogUploadExcel" width="39%"
      :before-close="handleClose">
      <div style="text-align:left;">
        <p>Excelファイルを利用して、複数の従業員の情報を一括で登録できます。</p>
      </div>
      <div>
        <el-row>
          <div class="el-form-item__content" style="padding-top:20px;">
            <el-upload ref="upload" accept=".xls,.xlsx" action="#" :auto-upload="false" :multiple="false"
              :file-list="fileList" :before-upload="beforeUpload" :http-request="uploadHttpRequest"
              :on-remove="fileRemove" :on-change="fileChange">
              <el-button size="medium" type="primary" icon="el-icon-folder-opened">ファイルを選択</el-button>
              <div slot="tip" class="el-upload__tip">
                <span style="color:red;">＊一回で一枚「.xlsx」ファイルのみ取込、かつ最大ファイルサイズ10Mまで。</span>
              </div>
            </el-upload>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-download" style="padding-bottom:50px;">
            <el-link @click="ExcelSample()" target="_blank">
              <span style="color:#20a0ff;">テンプレートファイルをダウンロード</span>
            </el-link>
          </div>
        </el-row>
        <el-row>
          <el-button type="primary" size="small" @click="submitUpload" style="width:100px;">取り込み</el-button>
          <el-button size="small" @click="closeDialog" style="width:100px;">キャンセル</el-button>
        </el-row>
        <el-row>
          <div style="text-align:left; padding-top:10px;">
            <el-form :model="ruleForm" :label-position="labelPosition" label-width="100px">
              <el-form-item>
                <span>{{ruleForm.insertEmpCount}}</span>&nbsp;件が取り込みました。
                未取込データ&nbsp;<span style="color:red;">{{ruleForm.noInsertEmpCount}}</span>&nbsp;件があります。
              </el-form-item>
            </el-form>
          </div>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="closeDialog" type="primary" size="medium">閉じる</el-button>
      </span>
    </el-dialog>

    <!-- empList Add -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="86%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="170px"
        class="demo-ruleForm" size="mini">
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item :title="$t('empList.general_info')" name="1" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.name')" prop="name" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.nameP')"></el-input>
                    <el-popover placement="top-start" title="氏名記入方法:" width="300" trigger="hover"
                      content="代表者氏名を全角で入力してください。姓と名前の間に全角スペースを入れてください。外国籍の氏名が漢字表記ではない場合、全角アルファベット（大文字）もしくは全角カタカナで入力してください。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('general.employee_id')" prop="employee_id" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.employee_id" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.employee_idP')"></el-input>
                    <el-popover placement="top-start" title="社員番号:" width="300" trigger="hover"
                      content="社員番号は新規登録した後再変更できませんので、ご注意ください。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('empList.nation')" prop="nation" style="margin-left: 50px">
                    <el-select style="margin-right: 0px; width: 280px" :class="selectBg" placeholder="選択ください"
                      v-model="ruleForm.nation" filterable clearable>
                      <el-option-group :class="groupBg" v-for="group in country" :key="group.label"
                        :label="group.label">
                        <el-option :disabled="item.disabled" v-for="item in group.options" :key="item.value"
                          :label="item.value" :value="item.value" type="button"></el-option>
                      </el-option-group>
                    </el-select>
                    <!-- <foreign-area v-model="ruleForm.nation" popularCity="popularCity" selectBg="" groupBg="" @selectCountry="监听选中的国家"></foreign-area> -->
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != true" :label="$t('empList.birthday')" prop="birthday"
                    style="margin-left:50px">
                    <el-date-picker @change="DateInput11(ruleForm.birthday)" v-model="ruleForm.birthday" size="mini"
                      value-format="yyyy-MM-dd" style="margin-right:10px;width:185px" placeholder="例:1996-3-20"
                      type="date"></el-date-picker>
                    <span> {{ dateForm.DateInput11 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != false" :label="$t('empList.birthday')" prop="birthday"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" @change="DateInput12(ruleForm.birthday)"
                      v-model="ruleForm.birthday" size="mini" style="margin-right:0px;width:185px"
                      placeholder="例:H8/3/20" clearable=""></el-input>&nbsp;&nbsp;
                    <span> {{ dateForm.DateInput12 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item :label="$t('empList.gender')" prop="gender" style="margin-left: 50px">
                    <el-radio-group v-model="ruleForm.gender" style="margin-left: 0px">
                      <el-radio :label="$t('empList.male')">{{
                        $t("empList.male")
                        }}</el-radio>
                      <el-radio style="margin-left: 50px" :label="$t('empList.female')">{{ $t("empList.female") }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.name_frgn')" prop="name_frgn">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name_frgn" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.name_frgnP')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.email')" prop="email">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.email" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.emailP')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.mynum')" prop="mynum">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.mynum" size="mini" style="width: 280px"
                      :placeholder="$t('empList.mynumP')"></el-input>
                    <el-popover placement="top-start" title="マイナンバーとは:" width="250" trigger="hover"
                      content="マイナンバーとは、日本に住民票を有するすべての方（外国人の方も含まれます。）が持つ12桁の番号です。※原則として自由に変更することはできません。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="扶養親族人数" prop="dependent_number">
                    <el-select v-model="ruleForm.dependent_number" size="mini" style="margin-right: 0px; width: 280px">
                      <el-option v-for="item in dependent_number" :key="item.id" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <el-popover placement="top-start" title="甲欄・乙欄:" width="250" trigger="hover"
                      content="月額表の甲欄を適用する給与に限り、財務省が告示する計算式により算出できます。「乙欄」は「給与所得者の扶養控除等申告書」の提出がない方に適用されます。扶養親族等の数については、税額計算上の人数です。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.assign_resign')" name="2">
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('empList.begin_date')" prop="begin_date" style="margin-left: 50px">
                  <el-date-picker v-model="ruleForm.begin_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-right: 70px; width: 280px" type="date" :placeholder="$t('empList.begin_dateP')">
                  </el-date-picker>
                </el-form-item>

                <el-form-item :label="$t('empList.end_date')" prop="end_date" style="margin-left: 50px">
                  <el-date-picker v-model="ruleForm.end_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-right: 70px; width: 280px" type="date" :placeholder="$t('empList.end_dateP')">
                  </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('empList.work_status')" prop="work_status">
                  <el-select v-model="ruleForm.work_status" clearable style="margin-right: 90px; width: 280px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in status" :key="item.statusId" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empList.cause')" prop="cause">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.cause" size="mini"
                    style="margin-right: 90px; width: 280px" placeholder></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.office_info')" name="3">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.employee_type')" prop="employee_type" style="margin-left: 50px">
                    <el-select v-model="ruleForm.employee_type" style="margin-right: 90px; width: 280px"
                      :placeholder="$t('general.select')" size="mini">
                      <el-option v-for="item in employee_types" :key="item.employee_types_id" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('empList.work_content')" prop="work_content" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.work_content" size="mini"
                      style="margin-right: 70px; width: 280px" :placeholder="$t('empList.work_contentP')"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.title')" prop="title">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.title" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.titleP')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('empList.contact_info')" name="4">
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item :label="$t('empList.postal_code')" prop="post_code" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post_code" size="mini"
                      style="margin-right: 70px; width: 280px" :placeholder="$t('empList.postal_code_example')"
                      @change="searchLocation">
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.address1')" prop="address1" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address1" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.city')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.address2')" prop="address2" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address2" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.street')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('empList.address3')" prop="address3" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address3" size="mini"
                      style="margin-right: 70px; width: 280px" :placeholder="$t('empList.building')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.tel')" prop="tel" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.tel" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.telP')"></el-input>
                    <el-popover placement="top-start" title="電話番号の書き方:" width="250" trigger="hover"
                      content="半角数字で入力してください。市外局番と市内局番、市内局番と加入者番号の間にハイフン（－）を記入してください。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item label="住所（フリガナ）" prop="address_frgn1">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_kn1" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.city')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.address_frgn2')" prop="address_frgn2">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_kn2" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.street')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('empList.address_frgn3')" prop="address_frgn3">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_kn3" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.building')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('empList.salary')" name="5">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.bank_name')" prop="bank_name" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_name" size="mini"
                      style="margin-right: 90px; width: 280px" placeholder="例：愛知銀行"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.bank_branch')" prop="bank_branch" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_branch" size="mini"
                      style="margin-right: 90px; width: 280px" placeholder="例：三郷支店"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.bank_code')" prop="bank_code" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_code" size="mini"
                      style="margin-right: 90px; width: 280px" placeholder="例：0542"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.deposit_type')" prop="deposit_type" style="margin-left: 50px">
                    <el-select v-model="ruleForm.deposit_type" clearable style="margin-right: 90px; width: 280px"
                      size="mini" :placeholder="$t('general.select')">
                      <el-option v-for="item in deposit_types" :key="item.deposit_types_id" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('empList.account_name')" prop="account_name" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.account_name" size="mini"
                      style="margin-right: 70px; width: 280px" placeholder="例：山田　太郎"></el-input>
                  </el-form-item>

                  <el-form-item label="" prop="account_name" style="margin-left: 50px">
                    <el-link type="primary" class="el-icon-info" :underline="false" href="https://zengin.ajtw.net/"
                      target="_blank">金融機関検索</el-link>
                  </el-form-item>

                  <!-- <el-form-item :label="$t('empList.commuting_fee')" prop="commuting_fee" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.commuting_fee" size="mini" style="margin-right: 70px; width: 280px" :placeholder="$t('empList.commuting_fee')"></el-input>
                  </el-form-item> -->
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.bank_name_frgn')" prop="bank_name_frgn">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_name_frgn" size="mini"
                      style="margin-right: 90px; width: 280px" placeholder="例：ｱｲﾁ"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.bank_branch_frgn')" prop="bank_branch_frgn">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_branch_frgn" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.bank_branch_frgn')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.branch_code')" prop="branch_code">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.branch_code" size="mini"
                      style="margin-right: 90px; width: 280px" placeholder="例：ｻﾝｺﾞｳ"></el-input>
                  </el-form-item>

                  <el-form-item v-if="accountType != true" :label="$t('empList.account')" prop="account">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.account" size="mini"
                      style="margin-right: 10px; width: 280px" placeholder="口座番号（半角）"></el-input>
                    <el-checkbox v-model="accountType">ゆうちょ銀行</el-checkbox>
                  </el-form-item>
                  <el-form-item v-if="accountType != false" :label="$t('empList.accountU')" prop="account">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.account" size="mini"
                      style="margin-right: 10px; width: 280px" placeholder="11960-1234567"></el-input>
                    <el-checkbox v-model="accountType">ゆうちょ銀行</el-checkbox>
                  </el-form-item>

                  <el-form-item :label="$t('empList.salary_month')" prop="salary_month">
                    <el-input @change="handleToMoney" prefix-icon="el-icon-edit" v-model="ruleForm.salary_month"
                      size="mini" style="margin-right: 90px; width: 280px" :placeholder="$t('empList.salary_month')">
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.salary_changeday')" prop="salary_changeday">
                    <el-date-picker v-model="ruleForm.salary_changeday" size="mini" value-format="yyyy-MM-dd"
                      style="margin-right: 70px; width: 280px" type="date"
                      :placeholder="$t('empList.salary_changeday')">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.resident_info')" name="6">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.resident')" prop="resident" style="margin-left: 50px">
                    <el-select v-model="ruleForm.resident" style="margin-right: 70px; width: 280px"
                      :placeholder="$t('general.select')" size="mini">
                      <el-option v-for="item in residents" :key="item.residentsId" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div v-if="ruleForm.resident ===''">
                </div>
                <div v-else-if="ruleForm.resident ==='なし'">
                </div>
                <div v-else>
                  <el-form-item label="資格外活動許可" prop="licenses" style="margin-left: 50px">
                    <el-select v-model="ruleForm.licenses" style="margin-right: 70px; width: 280px"
                      :placeholder="$t('general.select')" size="mini">
                      <el-option v-for="item in licenses" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="氏名（ローマ字）" prop="name_rm" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name_rm" size="mini"
                      style="margin-right: 70px; width: 280px" placeholder="taro"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div v-if="ruleForm.resident ===''">
                </div>
                <div v-else-if="ruleForm.resident ==='なし'">
                </div>
                <div v-else>
                  <el-form-item :label="$t('empList.resident_code')" prop="resident_code">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.resident_code" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.resident_code')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('empList.resident_date')" prop="resident_date">
                    <el-date-picker v-model="ruleForm.resident_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-right: 90px; width: 280px" type="date"></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.insurance_info')" name="7">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.emp_insuranceID')" prop="emp_insuranceID" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.emp_insuranceID" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.emp_insuranceID')"></el-input>
                    <el-popover placement="top-start" title="雇用保険番号とは:" width="300" trigger="hover"
                      content="被保険者番号は、「4桁-6桁-1桁」で構成される、合計11桁の番号です。 会社に入社して雇用保険に加入すると原則一人にひとつ割り当てられ、退職後に転職先で再度雇用保険に加入する際も同じ被保険者番号を使います。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                  <el-form-item :label="$t('empList.emp_ins_begin_day')" prop="emp_ins_begin_day"
                    style="margin-left: 50px">
                    <el-date-picker v-model="ruleForm.emp_ins_begin_day" size="mini" value-format="yyyy-MM-dd"
                      style="margin-right: 0px; width: 280px" type="date"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('empList.emp_ins_end_day')" prop="emp_ins_end_day" style="margin-left: 50px">
                    <el-date-picker v-model="ruleForm.emp_ins_end_day" size="mini" value-format="yyyy-MM-dd"
                      style="margin-right: 0px; width: 280px" type="date"></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.basic_pensionID')" prop="basic_pensionID">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.basic_pensionID" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.basic_pensionIDP')"></el-input>
                    <el-popover placement="top-start" title="基礎年金番号は:" width="250" trigger="hover"
                      content="国民年金・厚生年金保険・共済組合といったすべての公的年金制度で共通して使用する「一人に一つの番号」です。 基礎年金番号の体系基礎年金番号は10桁の数字で表され、4桁と6桁の組み合わせとなっています。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('empList.pensionID')" prop="pensionID">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.pensionID" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.pensionIDP')"></el-input>
                    <el-popover placement="top-start" title="厚生年金整理番号とは:" width="250" trigger="hover"
                      content="厚生年金資格取得届等の控えを見て確認します。健康保険被保険者整理番号と共通の数字なっていることが多いですが、異なる場合もありますので厚生年金資格取得届等の控えを参照します。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('empList.health_insuranceID')" prop="health_insuranceID">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.health_insuranceID" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.health_insuranceIDP')">
                    </el-input>
                    <el-popover placement="top-start" title="健康保険番号とは:" width="250" trigger="hover"
                      content="健康保険番号は、健康保険証の券面に記載があります。全国健康保険協会の場合、健康保険証の表面・上部に記載されている「記号・番号」欄の「番号」にあたる部分が健康保険被保険者整理番号となります。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAddEmp('ruleForm')" style="width: 120px" type="primary" size="medium">
          {{ $t("general.confirm") }}</el-button>
        <el-button @click="s1_cancel('ruleForm')" style="width: 120px" size="medium">{{ $t("general.cancel") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- empList Edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="86%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="170px"
        class="demo-ruleForm" size="mini">
        <el-collapse accordion>
          <el-collapse-item :title="$t('empList.general_info')" name="1" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.name')" prop="name" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.nameP')"></el-input>
                    <el-popover placement="top-start" title="氏名記入方法:" width="300" trigger="hover"
                      content="代表者氏名を全角で入力してください。姓と名前の間に全角スペースを入れてください。外国籍の氏名が漢字表記ではない場合、全角アルファベット（大文字）もしくは全角カタカナで入力してください。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('general.employee_id')" prop="employee_id" style="margin-left: 50px">
                    <el-input readonly="readonly" prefix-icon="el-icon-edit" v-model="ruleForm.employee_id" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.employee_idP')"></el-input>
                    <el-popover placement="top-start" title="社員番号:" width="300" trigger="hover"
                      content="社員番号は新規登録した後再変更できませんので、ご注意ください。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('empList.nation')" prop="nation" style="margin-left: 50px">
                    <el-select style="margin-right: 0px; width: 280px" :class="selectBg" placeholder="選択ください"
                      v-model="ruleForm.nation" filterable clearable>
                      <el-option-group :class="groupBg" v-for="group in country" :key="group.label"
                        :label="group.label">
                        <el-option :disabled="item.disabled" v-for="item in group.options" :key="item.value"
                          :label="item.value" :value="item.value" type="button"></el-option>
                      </el-option-group>
                    </el-select>
                    <!-- <foreign-area @selectCountry="selectCountry"></foreign-area> -->
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != true" :label="$t('empList.birthday')" prop="birthday"
                    style="margin-left:50px">
                    <el-date-picker @change="DateInput11(ruleForm.birthday)" v-model="ruleForm.birthday" size="mini"
                      value-format="yyyy-MM-dd" style="margin-right:10px;width:185px" placeholder="例:1996-3-20"
                      type="date"></el-date-picker>
                    <span> {{ dateForm.DateInput11 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != false" :label="$t('empList.birthday')" prop="birthday"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" @change="DateInput12(ruleForm.birthday)"
                      v-model="ruleForm.birthday" size="mini" style="margin-right:0px;width:185px"
                      placeholder="例:H8/3/20" clearable=""></el-input>&nbsp;&nbsp;
                    <span> {{ dateForm.DateInput12 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <!-- <el-form-item :label="$t('empList.birthday')" prop="birthday" style="margin-left: 50px">
                    <el-date-picker :picker-options="pickerOptions" v-model="ruleForm.birthday" size="mini" value-format="yyyy-MM-dd" style="margin-right: 70px; width: 280px" type="date" :placeholder="$t('empList.birthdayP')">
                    </el-date-picker>
                  </el-form-item> -->

                  <el-form-item :label="$t('empList.gender')" prop="gender" style="margin-left: 50px">
                    <el-radio-group v-model="ruleForm.gender" style="margin-left: 0px">
                      <el-radio :label="$t('empList.male')">{{
                        $t("empList.male")
                        }}</el-radio>
                      <el-radio style="margin-left: 50px" :label="$t('empList.female')">{{ $t("empList.female") }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.name_frgn')" prop="name_frgn">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name_frgn" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.name_frgnP')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.email')" prop="email">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.email" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.emailP')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.mynum')" prop="mynum">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.mynum" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.mynumP')"></el-input>
                    <el-popover placement="top-start" title="マイナンバーとは:" width="250" trigger="hover"
                      content="マイナンバーとは、日本に住民票を有するすべての方（外国人の方も含まれます。）が持つ12桁の番号です。※原則として自由に変更することはできません。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="扶養親族人数" prop="dependent_number">
                    <el-select v-model="ruleForm.dependent_number" size="mini" style="margin-right: 0px; width: 280px">
                      <el-option v-for="item in dependent_number" :key="item.id" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <el-popover placement="top-start" title="甲欄・乙欄:" width="250" trigger="hover"
                      content="月額表の甲欄を適用する給与に限り、財務省が告示する計算式により算出できます。「乙欄」は「給与所得者の扶養控除等申告書」の提出がない方に適用されます。扶養親族等の数については、税額計算上の人数です。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.assign_resign')" name="2">
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('empList.begin_date')" prop="begin_date" style="margin-left: 50px">
                  <el-date-picker v-model="ruleForm.begin_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-right: 70px; width: 280px" type="date" :placeholder="$t('empList.begin_dateP')">
                  </el-date-picker>
                </el-form-item>

                <el-form-item :label="$t('empList.end_date')" prop="end_date" style="margin-left: 50px">
                  <el-date-picker v-model="ruleForm.end_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-right: 70px; width: 280px" type="date" :placeholder="$t('empList.end_dateP')">
                  </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('empList.work_status')" prop="work_status">
                  <el-select v-model="ruleForm.work_status" style="margin-right: 90px; width: 280px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in status" :key="item.statusId" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empList.cause')" prop="cause">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.cause" size="mini"
                    style="margin-right: 90px; width: 280px" placeholder></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.office_info')" name="3">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.employee_type')" prop="employee_type" style="margin-left: 50px">
                    <el-select v-model="ruleForm.employee_type" style="margin-right: 90px; width: 280px" size="mini">
                      <el-option v-for="item in employee_types" :key="item.employee_types_id" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('empList.work_content')" prop="work_content" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.work_content" size="mini"
                      style="margin-right: 70px; width: 280px" :placeholder="$t('empList.work_contentP')"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.title')" prop="title">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.title" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.titleP')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('empList.contact_info')" name="4">
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item :label="$t('empList.postal_code')" prop="post_code" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post_code" size="mini"
                      style="margin-right: 70px; width: 280px" :placeholder="$t('empList.postal_code_example')"
                      @change="searchLocation" clearable>
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.address1')" prop="address1" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address1" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.city')" clearable></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.address2')" prop="address2" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address2" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.street')" clearable></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('empList.address3')" prop="address3" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address3" size="mini"
                      style="margin-right: 70px; width: 280px" :placeholder="$t('empList.building')" clearable>
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.tel')" prop="tel" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.tel" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.telP')" clearable></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item label="住所（フリガナ）" prop="address_frgn1">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_kn1" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.city')" clearable></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.address_frgn2')" prop="address_frgn2">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_kn2" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.street')" clearable></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('empList.address_frgn3')" prop="address_frgn3">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_kn3" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.building')" clearable>
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('empList.salary')" name="5">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.bank_name')" prop="bank_name" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_name" size="mini"
                      style="margin-right: 90px; width: 280px" placeholder="例：愛知銀行"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.bank_branch')" prop="bank_branch" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_branch" size="mini"
                      style="margin-right: 90px; width: 280px" placeholder="例：三郷支店"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.bank_code')" prop="bank_code" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_code" size="mini"
                      style="margin-right: 90px; width: 280px" placeholder="例：0542"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.deposit_type')" prop="deposit_type" style="margin-left: 50px">
                    <el-select v-model="ruleForm.deposit_type" clearable style="margin-right: 90px; width: 280px"
                      size="mini" :placeholder="$t('general.select')">
                      <el-option v-for="item in deposit_types" :key="item.deposit_types_id" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('empList.account_name')" prop="account_name" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.account_name" size="mini"
                      style="margin-right: 70px; width: 280px" placeholder="例：山田　太郎"></el-input>
                  </el-form-item>

                  <el-form-item label="" prop="account_name" style="margin-left: 50px">
                    <el-link type="primary" class="el-icon-info" :underline="false" href="https://zengin.ajtw.net/"
                      target="_blank">金融機関検索</el-link>
                  </el-form-item>

                  <!-- <el-form-item :label="$t('empList.commuting_fee')" prop="commuting_fee" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.commuting_fee" size="mini" style="margin-right: 70px; width: 280px" :placeholder="$t('empList.commuting_fee')"></el-input>
                  </el-form-item> -->
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.bank_name_frgn')" prop="bank_name_frgn">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_name_frgn" size="mini"
                      style="margin-right: 90px; width: 280px" placeholder="例：ｱｲﾁ"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.bank_branch_frgn')" prop="bank_branch_frgn">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_branch_frgn" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.bank_branch_frgn')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.branch_code')" prop="branch_code">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.branch_code" size="mini"
                      style="margin-right: 90px; width: 280px" placeholder="例：ｻﾝｺﾞｳ"></el-input>
                  </el-form-item>

                  <el-form-item v-if="accountType != true" :label="$t('empList.account')" prop="account">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.account" size="mini"
                      style="margin-right: 10px; width: 280px" placeholder="口座番号（半角）"></el-input>
                    <el-checkbox v-model="accountType">ゆうちょ銀行</el-checkbox>
                  </el-form-item>
                  <el-form-item v-if="accountType != false" :label="$t('empList.accountU')" prop="account">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.account" size="mini"
                      style="margin-right: 10px; width: 280px" placeholder="11960-1234567"></el-input>
                    <el-checkbox v-model="accountType">ゆうちょ銀行</el-checkbox>
                  </el-form-item>

                  <el-form-item :label="$t('empList.salary_month')" prop="salary_month">
                    <el-input @change="handleToMoney" prefix-icon="el-icon-edit" v-model="ruleForm.salary_month"
                      size="mini" style="margin-right: 90px; width: 280px" :placeholder="$t('empList.salary_month')">
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empList.salary_changeday')" prop="salary_changeday">
                    <el-date-picker v-model="ruleForm.salary_changeday" size="mini" value-format="yyyy-MM-dd"
                      style="margin-right: 70px; width: 280px" type="date"
                      :placeholder="$t('empList.salary_changeday')">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.resident_info')" name="6">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.resident')" prop="resident" style="margin-left: 50px">
                    <el-select v-model="ruleForm.resident" style="margin-right: 70px; width: 280px"
                      :placeholder="$t('general.select')" size="mini">
                      <el-option v-for="item in residents" :key="item.residentsId" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <div v-if="ruleForm.resident ===''">
                </div>
                <div v-else-if="ruleForm.resident ==='なし'">
                </div>
                <div v-else>
                  <el-form-item label="資格外活動許可" prop="licenses" style="margin-left: 50px">
                    <el-select v-model="ruleForm.licenses" style="margin-right: 70px; width: 280px"
                      :placeholder="$t('general.select')" size="mini">
                      <el-option v-for="item in licenses" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="氏名（ローマ字）" prop="name_rm" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name_rm" size="mini"
                      style="margin-right: 70px; width: 280px" placeholder="taro"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div v-if="ruleForm.resident ===''">
                </div>
                <div v-else-if="ruleForm.resident ==='なし'">
                </div>
                <div v-else>
                  <el-form-item :label="$t('empList.resident_code')" prop="resident_code">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.resident_code" size="mini"
                      style="margin-right: 90px; width: 280px" :placeholder="$t('empList.resident_code')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('empList.resident_date')" prop="resident_date">
                    <el-date-picker v-model="ruleForm.resident_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-right: 90px; width: 280px" type="date"></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.insurance_info')" name="7">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.emp_insuranceID')" prop="emp_insuranceID" style="margin-left: 50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.emp_insuranceID" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.emp_insuranceID')"></el-input>
                    <el-popover placement="top-start" title="雇用保険番号とは:" width="300" trigger="hover"
                      content="被保険者番号は、「4桁-6桁-1桁」で構成される、合計11桁の番号です。 会社に入社して雇用保険に加入すると原則一人にひとつ割り当てられ、退職後に転職先で再度雇用保険に加入する際も同じ被保険者番号を使います。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                  <el-form-item :label="$t('empList.emp_ins_begin_day')" prop="emp_ins_begin_day"
                    style="margin-left: 50px">
                    <el-date-picker v-model="ruleForm.emp_ins_begin_day" size="mini" value-format="yyyy-MM-dd"
                      style="margin-right: 0px; width: 280px" type="date"></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('empList.emp_ins_end_day')" prop="emp_ins_end_day" style="margin-left: 50px">
                    <el-date-picker v-model="ruleForm.emp_ins_end_day" size="mini" value-format="yyyy-MM-dd"
                      style="margin-right: 0px; width: 280px" type="date"></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empList.basic_pensionID')" prop="basic_pensionID">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.basic_pensionID" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.basic_pensionIDP')"></el-input>
                    <el-popover placement="top-start" title="基礎年金番号は:" width="250" trigger="hover"
                      content="国民年金・厚生年金保険・共済組合といったすべての公的年金制度で共通して使用する「一人に一つの番号」です。 基礎年金番号の体系基礎年金番号は10桁の数字で表され、4桁と6桁の組み合わせとなっています。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('empList.pensionID')" prop="pensionID">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.pensionID" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.pensionIDP')"></el-input>
                    <el-popover placement="top-start" title="厚生年金整理番号とは:" width="250" trigger="hover"
                      content="厚生年金資格取得届等の控えを見て確認します。健康保険被保険者整理番号と共通の数字なっていることが多いですが、異なる場合もありますので厚生年金資格取得届等の控えを参照します。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('empList.health_insuranceID')" prop="health_insuranceID">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.health_insuranceID" size="mini"
                      style="margin-right: 0px; width: 280px" :placeholder="$t('empList.health_insuranceIDP')">
                    </el-input>
                    <el-popover placement="top-start" title="健康保険番号とは:" width="250" trigger="hover"
                      content="健康保険番号は、健康保険証の券面に記載があります。全国健康保険協会の場合、健康保険証の表面・上部に記載されている「記号・番号」欄の「番号」にあたる部分が健康保険被保険者整理番号となります。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="handleUpdateEmp('ruleForm')" type="primary" size="medium">
          {{ $t("general.confirm") }}</el-button>
        <el-button style="width: 120px" @click="s1_cancel('ruleForm')" size="medium">{{ $t("general.cancel") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- Family Info -->
    <el-dialog :title="$t('empList.family_info')" :append-to-body="true" :visible.sync="dialogFamily" width="80%"
      :before-close="handleClose">
      <div align="left" style="margin-top:20px;margin-bottom:39px;float:left;">
        &emsp;社員名:&emsp;{{ruleForm.name}}<br>&emsp;社員番号:&emsp;{{ruleForm.employee_id}}
      </div>
      <div align="right" style="margin-top:20px;margin-bottom:39px;margin-right:96px">
        <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="doAdd()">撫養親族追加
        </el-button>
      </div>
      <el-table v-loading="loading" :data="familyData" highlight-current-row border style="width: 100%"
        :empty-text="$t('general.empty_data')">
        <el-table-column label="氏名" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name_family }}</span>
          </template>
        </el-table-column>
        <el-table-column label="性別" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.gender }}</span>
          </template>
        </el-table-column>
        <el-table-column label="生年月日" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.birthday_family }}</span>
          </template>
        </el-table-column>
        <el-table-column label="従業員との続柄" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.relation }}</span>
          </template>
        </el-table-column>
        <el-table-column label="見積額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.income }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="300px;">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="familyEdit(scope.$index, scope.row)">
              {{$t("general.edit")}}</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete"
              @click="handleFamilyDelete(scope.$index, scope.row)">
              {{$t("general.delete")}}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="cancel()" type="primary" size="medium">{{ $t("general.close") }}
        </el-button>
      </span>
    </el-dialog>

    <!--edit family-->
    <el-dialog :title="$t('empList.new_family_info')" :append-to-body="true" :visible.sync="updateFamily" width="86%"
      :before-close="handleClose">
      <el-form :model="ruleFamily" :rules="rules" ref="ruleFamily" label-width="210px" class="demo-ruleForm"
        size="medium" style="margin-left:20px" :label-position="labelPosition">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="基本情報" name="1">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="氏名" prop="name_family">
                    <el-input v-model="ruleFamily.name_family" size="mini" style="margin-left:10px;width: 185px"
                      placeholder="入力してください" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="国籍・地域" prop="nation">
                    <el-select size="mini" style="margin-left: 10px; width: 185px" class="selectBg" placeholder="国選択"
                      v-model="ruleFamily.nation" filterable clearable>
                      <el-option-group class="groupBg" v-for="group in country" :key="group.label" :label="group.label">
                        <el-option :disabled="item.disabled" v-for="item in group.options" :key="item.value"
                          :label="item.value" :value="item.value" type="button"></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="性別" prop="gender">
                    <el-radio-group v-model="ruleFamily.gender" style="margin-left: 10px">
                      <el-radio :label="$t('empList.male')">{{
                        $t("empList.male")
                        }}</el-radio>
                      <el-radio style="margin-left: 50px" :label="$t('empList.female')">{{ $t("empList.female") }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item :label="$t('empList.relation')" prop="relation">
                    <el-select :placeholder="$t('general.select')" v-model="ruleFamily.relation"
                      style="margin-left: 10px; width: 185px" size="mini">
                      <el-option v-for="item in relations" :key="item.relationsId" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="氏名（フリガナ）" prop="name_frgn_family">
                    <el-input v-model="ruleFamily.name_frgn_family" size="mini" style="margin-left:10px;width: 185px"
                      placeholder="入力してください" clearable></el-input>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != true" :label="$t('empList.birthday')"
                    prop="birthday_family">
                    <el-date-picker @change="DateInput11(ruleFamily.birthday_family)"
                      v-model="ruleFamily.birthday_family" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width:185px" placeholder="例:1996-3-20" type="date"></el-date-picker>
                    <span> {{ dateForm.DateInput11 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != false" :label="$t('empList.birthday')"
                    prop="birthday_family">
                    <el-input prefix-icon="el-icon-edit" @change="DateInput12(ruleFamily.birthday_family)"
                      v-model="ruleFamily.birthday_family" size="mini" style="margin-left:10px;width:185px"
                      placeholder="例:H8/3/20" clearable=""></el-input>
                    <span> {{ dateForm.DateInput12 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item label="マイナンバー" prop="mynum_family">
                    <el-input v-model="ruleFamily.mynum_family" size="mini" style="margin-left:10px;width: 185px">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="見積額" prop="income">
                    <el-input @change="empFamilyFormToMoney()" v-model="ruleFamily.income" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                    &nbsp;円
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="住所" prop="address">
                    <el-input v-model="ruleFamily.address" size="mini" style="margin-left:10px;width:810px"></el-input>
                    <el-checkbox @change="togetherChange()" v-model="ruleFamily.together">同居</el-checkbox>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="控除申告情報" name="2">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="非居住者である" prop="non_resident_is">
                    <el-checkbox v-model="ruleFamily.non_resident_is" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="源泉控除対象該当" prop="withholding_d_is">
                    <el-checkbox v-model="ruleFamily.withholding_d_is" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="扶養区分" prop="raise_division">
                    <el-select v-model="ruleFamily.raise_division" size="mini" placeholder="選択"
                      style="margin-left:10px;width: 185px" clearable>
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="生計を一にする事実" prop="money_raise">
                    <el-input @change="empFamilyFormToMoney()" v-model="ruleFamily.money_raise" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                    &nbsp;円
                    <el-popover placement="top-start" title="ヒント:" width="190" trigger="hover"
                      content="「生計を一にする事実」欄に配偶者にその年に送金等をした金額の合計額を記入します。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="撫養控除対象対象外" prop="raise_d_not">
                    <el-checkbox v-model="ruleFamily.raise_d_not" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="障害者区分" prop="disabled_division">
                    <el-select v-model="ruleFamily.disabled_division" size="mini" placeholder="選択"
                      style="margin-left:10px;width: 185px" clearable>
                      <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="異動月日及び事由" prop="cause">
                    <el-input v-model="ruleFamily.cause" size="mini" style="margin-left:10px;width:810px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="メモ" prop="memo">
                    <el-input v-model="ruleFamily.memo" size="mini" style="margin-left:10px;width:810px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="EditFamily('ruleFamily')" type="primary" size="medium">
          {{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="s1_cancelFamily('ruleFamily')" size="medium">{{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <!--add family-->
    <el-dialog :title="$t('empList.new_family_info')" :append-to-body="true" :visible.sync="addFamily" width="86%"
      :before-close="handleClose">
      <el-form :model="ruleFamily" :rules="rules" ref="ruleFamily" label-width="210px" class="demo-ruleForm"
        size="medium" style="margin-left:20px" :label-position="labelPosition">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="基本情報" name="1">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="氏名" prop="name_family">
                    <el-input v-model="ruleFamily.name_family" size="mini" style="margin-left:10px;width: 185px"
                      placeholder="入力してください" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="国籍・地域" prop="nation">
                    <el-select size="mini" style="margin-left: 10px; width: 185px" class="selectBg" placeholder="国選択"
                      v-model="ruleFamily.nation" filterable clearable>
                      <el-option-group class="groupBg" v-for="group in country" :key="group.label" :label="group.label">
                        <el-option :disabled="item.disabled" v-for="item in group.options" :key="item.value"
                          :label="item.value" :value="item.value" type="button"></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="性別" prop="gender">
                    <el-radio-group v-model="ruleFamily.gender" style="margin-left: 10px">
                      <el-radio :label="$t('empList.male')">{{
                        $t("empList.male")
                        }}</el-radio>
                      <el-radio style="margin-left: 50px" :label="$t('empList.female')">{{ $t("empList.female") }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item :label="$t('empList.relation')" prop="relation">
                    <el-select :placeholder="$t('general.select')" v-model="ruleFamily.relation"
                      style="margin-left: 10px; width: 185px" size="mini">
                      <el-option v-for="item in relations" :key="item.relationsId" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="氏名（フリガナ）" prop="name_frgn_family">
                    <el-input v-model="ruleFamily.name_frgn_family" size="mini" style="margin-left:10px;width: 185px"
                      placeholder="入力してください" clearable></el-input>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != true" :label="$t('empList.birthday')"
                    prop="birthday_family">
                    <el-date-picker @change="DateInput11(ruleFamily.birthday_family)"
                      v-model="ruleFamily.birthday_family" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width:185px" placeholder="例:1996-3-20" type="date"></el-date-picker>
                    <span> {{ dateForm.DateInput11 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != false" :label="$t('empList.birthday')"
                    prop="birthday_family">
                    <el-input prefix-icon="el-icon-edit" @change="DateInput12(ruleFamily.birthday_family)"
                      v-model="ruleFamily.birthday_family" size="mini" style="margin-left:10px;width:185px"
                      placeholder="例:H8/3/20" clearable=""></el-input>
                    <span> {{ dateForm.DateInput12 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item label="マイナンバー" prop="mynum_family">
                    <el-input v-model="ruleFamily.mynum_family" size="mini" style="margin-left:10px;width: 185px">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="見積額" prop="income">
                    <el-input @change="empFamilyFormToMoney()" v-model="ruleFamily.income" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                    &nbsp;円
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="住所" prop="address">
                    <el-input v-model="ruleFamily.address" size="mini" style="margin-left:10px;width:810px"></el-input>
                    <el-checkbox @change="togetherChange()" v-model="ruleFamily.together">同居</el-checkbox>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="控除申告情報" name="2">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="非居住者である" prop="non_resident_is">
                    <el-checkbox v-model="ruleFamily.non_resident_is" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="源泉控除対象該当" prop="withholding_d_is">
                    <el-checkbox v-model="ruleFamily.withholding_d_is" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="扶養区分" prop="raise_division">
                    <el-select v-model="ruleFamily.raise_division" size="mini" placeholder="選択"
                      style="margin-left:10px;width: 185px" clearable>
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="生計を一にする事実" prop="money_raise">
                    <el-input @change="empFamilyFormToMoney()" v-model="ruleFamily.money_raise" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                    &nbsp;円
                    <el-popover placement="top-start" title="ヒント:" width="190" trigger="hover"
                      content="「生計を一にする事実」欄に配偶者にその年に送金等をした金額の合計額を記入します。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="撫養控除対象対象外" prop="raise_d_not">
                    <el-checkbox v-model="ruleFamily.raise_d_not" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>

                  <el-form-item label="障害者区分" prop="disabled_division">
                    <el-select v-model="ruleFamily.disabled_division" size="mini" placeholder="選択"
                      style="margin-left:10px;width: 185px" clearable>
                      <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="異動月日及び事由" prop="cause">
                    <el-input v-model="ruleFamily.cause" size="mini" style="margin-left:10px;width:810px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="メモ" prop="memo">
                    <el-input v-model="ruleFamily.memo" size="mini" style="margin-left:10px;width:810px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="AddFamily('ruleFamily')" type="primary" size="medium">
          {{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="s1_cancelFamily('ruleFamily')" size="medium">{{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <!--Detail-->
    <el-dialog :title="$t('general.detail')" :append-to-body="true" :visible.sync="dialogDetails" width="90%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="160px"
        class="demo-ruleForm" size="mini">
        <div>
          <el-row style="margin-left: 50px">
            <el-col style="margin-top: 39px" :span="8">
              <el-form-item :label="$t('empList.name')">
                :&emsp;{{ruleForm.name}}
              </el-form-item>

              <el-form-item :label="$t('empList.name_frgn')">
                :&emsp;{{ruleForm.name_frgn}}
              </el-form-item>

              <el-form-item :label="$t('empList.gender')">
                :&emsp;{{ruleForm.gender}}
              </el-form-item>

              <el-form-item label="扶養親族人数:">
                :&emsp;{{ruleForm.dependent_number}}
              </el-form-item>

            </el-col>
            <el-col style="margin-top: 39px" :span="9">
              <el-form-item :label="$t('empList.birthday')">
                :&emsp;{{ruleForm.birthday　| formatDate}}
              </el-form-item>

              <el-form-item :label="$t('empList.nation')">
                :&emsp;{{ruleForm.nation}}
              </el-form-item>

              <el-form-item :label="$t('empList.mynum')">
                :&emsp;{{ruleForm.mynum}}
              </el-form-item>

              <el-form-item :label="$t('empList.email')">
                :&emsp;{{ruleForm.email}}
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <div style="margin: 10px auto 10px; max-width: 80%; margin-left: 0px; text-align: center;">
                <el-upload class="avatar-uploader" action="/senseSys/empImgUpload" :data="uploadData"
                  :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                  style="margin-left: 70px;">
                  <img height="200" width="200" v-if="ruleForm.emp_img" :src="ruleForm.emp_img" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div style="margin: 10px auto 10px; max-width: 80%; margin-left: 70px; text-align: center;" slot="tip"
                  class="el-upload__tip">{{ $t("userHome.size_limit") }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <el-collapse v-model="activeNames" @change="handleChange" accordion>
          <el-collapse-item :title="$t('empList.assign_resign')" name="2">
            <el-row style="margin-left: 50px">
              <el-col :span="8">

                <el-form-item :label="$t('empList.begin_date')">
                  :&emsp;{{ruleForm.begin_date}}
                </el-form-item>

                <el-form-item :label="$t('empList.end_date')">
                  :&emsp;{{ruleForm.end_date}}
                </el-form-item>

              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('empList.work_status')">
                  :&emsp;{{ruleForm.work_status}}
                </el-form-item>

                <el-form-item :label="$t('empList.cause')">
                  :&emsp;{{ruleForm.cause}}
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.office_info')" name="3">
            <el-row style="margin-left: 50px">
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('empList.employee_type')">
                    :&emsp;{{ruleForm.employee_type}}
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('empList.title')">
                    :&emsp;{{ruleForm.title}}
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('empList.work_content')">
                    :&emsp;{{ruleForm.work_content}}
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('empList.contact_info')" name="4">
            <el-row style="margin-left: 50px">
              <el-col :sapn="24">
                <el-form-item label="住所">
                  :&emsp; 〒 {{ruleForm.post_code}}　
                  &nbsp;{{ruleForm.address1}}
                  &nbsp;{{ruleForm.address2}}
                  &nbsp;{{ruleForm.address3}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 50px">
              <el-col :span="24">
                <el-form-item label="住所（フリガナ）">
                  :&emsp; 〒 {{ruleForm.post_code}}　
                  &nbsp;{{ruleForm.address_kn1}}
                  &nbsp;{{ruleForm.address_kn2}}
                  &nbsp;{{ruleForm.address_kn3}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 50px">
              <el-col :span="10">
                <div>
                  <el-form-item :label="$t('empList.tel')">
                    :&emsp;{{ruleForm.tel}}
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('empList.salary')" name="5">
            <el-row style="margin-left: 50px">
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('empList.bank_name')">
                    :&emsp;{{ruleForm.bank_name}}
                  </el-form-item>

                  <el-form-item :label="$t('empList.account')">
                    :&emsp;{{ruleForm.account}}
                  </el-form-item>

                  <el-form-item :label="$t('empList.salary_month')">
                    :&emsp;{{ruleForm.salary_month}}
                  </el-form-item>

                  <!-- <el-form-item :label="$t('empList.commuting_fee')">
                    :&emsp;{{ruleForm.commuting_fee}}
                  </el-form-item> -->
                </div>
              </el-col>

              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('empList.bank_branch')">
                    :&emsp;{{ruleForm.bank_branch}}
                  </el-form-item>

                  <el-form-item :label="$t('empList.account_name')">
                    :&emsp;{{ruleForm.account_name}}
                  </el-form-item>

                </div>
              </el-col>

              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('empList.deposit_type')">
                    :&emsp;{{ruleForm.deposit_type}}
                  </el-form-item>

                  <el-form-item :label="$t('empList.salary_changeday')">
                    :&emsp;{{ruleForm.salary_changeday}}
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.resident_info')" name="6">
            <el-row style="margin-left: 50px">
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('empList.resident')">
                    :&emsp;{{ruleForm.resident}}
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('empList.resident_code')">
                    :&emsp;{{ruleForm.resident_code}}
                  </el-form-item>

                  <el-form-item label="在留期間満了日">
                    :&emsp;{{ruleForm.resident_date}}
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.insurance_info')" name="7">
            <el-row style="margin-left: 50px">
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('empList.emp_insuranceID')">
                    :&emsp;{{ruleForm.emp_insuranceID}}
                  </el-form-item>

                  <el-form-item :label="$t('empList.basic_pensionID')">
                    :&emsp;{{ruleForm.basic_pensionID}}
                  </el-form-item>

                </div>
              </el-col>

              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('empList.pensionID')">
                    :&emsp;{{ruleForm.pensionID}}
                  </el-form-item>

                  <el-form-item :label="$t('empList.health_insuranceID')">
                    :&emsp;{{ruleForm.health_insuranceID}}
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('empList.emp_ins_begin_day')">
                    :&emsp;{{ruleForm.emp_ins_begin_day}}
                  </el-form-item>

                  <el-form-item :label="$t('empList.emp_ins_end_day')">
                    :&emsp;{{ruleForm.emp_ins_end_day}}
                  </el-form-item>
                </div>
              </el-col>

            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="cancel()" type="primary" size="medium">{{ $t("general.close") }}
        </el-button>
      </span>
    </el-dialog>

    <!--Detail From Family-->
    <el-dialog :title="$t('empList.family_info')" :append-to-body="true" :visible.sync="dialogDetailsFromFamily"
      width="60%" :before-close="handleClose">
      <el-form :model="ruleFamily" :rules="rules" ref="ruleFamily" :data="uploadData" :label-position="labelPosition"
        label-width="170px" class="demo-ruleFamily" size="mini">
        <el-row style="margin-left: 50px">
          <el-col :span="12">
            <el-form-item class="label-style" :label="$t('empList.name')">
              :&emsp;{{ruleFamily.name_family}}
            </el-form-item>

            <el-form-item class="label-style" :label="$t('empList.name_frgn')">
              :&emsp;{{ruleFamily.name_frgn}}
            </el-form-item>

            <el-form-item class="label-style" :label="$t('empList.name_rm')">
              :&emsp;{{ruleFamily.name_rm}}
            </el-form-item>

            <el-form-item class="label-style" :label="$t('empList.birthday')">
              :&emsp;{{ruleFamily.birthday}}
            </el-form-item>

            <el-form-item class="label-style" :label="$t('empList.gender')">
              :&emsp;{{ruleFamily.gender}}
            </el-form-item>

          </el-col>

          <el-col :span="12">
            <el-form-item class="label-style" :label="$t('empList.relation')">
              :&emsp;{{ruleFamily.relation}}
            </el-form-item>

            <el-form-item class="label-style" :label="$t('empList.nation')">
              :&emsp;{{ruleFamily.nation}}
            </el-form-item>

            <el-form-item class="label-style" :label="$t('empList.mynum')">
              :&emsp;{{ruleFamily.mynum}}
            </el-form-item>

            <el-form-item class="label-style" :label="$t('empList.income')">
              :&emsp;{{ruleFamily.income}} &emsp; 円
            </el-form-item>
            <el-form-item class="label-style" :label="$t('empList.work')">
              :&emsp;{{ruleFamily.work}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-collapse @change="handleChange" accordion>
          <el-collapse-item :title="$t('empList.social_ins_status')" name="2" class="title">
            <el-row style="margin-left: 50px">
              <el-col :span="12">
                <el-form-item class="label-style" :label="$t('empList.social_ins_status')">
                  :&emsp;{{ruleFamily.social_ins_status}}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item class="label-style" :label="$t('empList.date')">
                  :&emsp;{{ruleFamily.date}}
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.tax_status')" name="3" class="title">
            <el-row style="margin-left: 50px">
              <el-col :span="12">
                <div></div>
              </el-col>

              <el-col :span="12">
                <div></div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empList.address')" name="4" class="title">
            <el-row style="margin-left: 50px">
              <el-col :span="24">
                <el-form-item class="label-style" :label="$t('empList.address')">
                  :&emsp;{{ruleFamily.address}}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <div></div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="cancelFamily()" type="primary" size="medium">{{ $t("general.close") }}
        </el-button>
      </span>
    </el-dialog>
    <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleSortChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {
    getRequest
  } from "../utils/api";
  import {
    postRequest
  } from "../utils/api";
  import {
    deleteRequest
  } from "../utils/api";
  import foreignArea from "@/components/Public/ForeignArea.vue"
  export default {
    components: { foreignArea },
    methods: {
      empFamilyFormToMoney() {
        if (this.ruleFamily.income != null && this.ruleFamily.income != "") {
          if (this.ruleFamily.income.indexOf(",") != -1) {
            this.ruleFamily.income = String(this.ruleFamily.income);
            this.ruleFamily.income = Number(this.ruleFamily.income.split(",").join(""));
          }
          this.ruleFamily.income = Number(this.ruleFamily.income).toLocaleString();
        }

        if (this.ruleFamily.money_raise != null && this.ruleFamily.money_raise != "") {
          if (this.ruleFamily.money_raise.indexOf(",") != -1) {
            this.ruleFamily.money_raise = String(this.ruleFamily.money_raise);
            this.ruleFamily.money_raise = Number(this.ruleFamily.money_raise.split(",").join(""));
          }
          this.ruleFamily.money_raise = Number(this.ruleFamily.money_raise).toLocaleString();
        }
      },
      togetherChange() {
        if (this.ruleFamily.together === true) {
          let postData = this.qs.stringify({
            employee_id: this.employee_id,
          });
          this.axios({
            method: "post",
            url: "/selectEmplistByEidAndUid",
            data: postData,
          })
            .then((response) => {
              this.ruleFamily.address = response.data.address1 + response.data.address2 + response.data.address3;
            })
            .catch((error) => {
            });
        } else {
          this.ruleFamily.address = "";
        }
      },
      pageFamily() {
        let postData = this.qs.stringify({
          eid: this.eid,
        });
        this.axios({
          method: "post",
          url: "/pageFamily",
          data: postData,
        })
          .then((response) => {
            for (var i = 0; i < response.data.length; i++) {
              response.data[i].income = Number(response.data[i].income).toLocaleString();
            }
            this.familyData = response.data;
          })
          .catch((error) => {
          });
      },
      deleteSalaryAll(index, row) {
        let postData = this.qs.stringify({
          employee_id: row.employee_id
        });
        this.axios({
          method: "post",
          url: "/deleteSalaryAll",
          data: postData,
        })
          .then(() => {
            this.$message({
              type: "success",
              message: "削除完了しました。"
            });
          })
          .catch((error) => {
            this.$message.error('エラー');
            console.log(error);
          });
      },
      handleDeleteAll(index, row) {
        let postData = this.qs.stringify({
          employee_id: row.employee_id,
          id: row.id
        });
        this.axios({
          method: "post",
          url: "/isSalaryExisting",
          data: postData,
        })
          .then((resp) => {
            if (resp.status == 200) {
              var json = resp.data;
              if (json.status == "not") {
                this.handleDelete(index, row);
              } else if (json.status == "is") {
                this.$confirm('この社員の給与明細情報を検出されたので、給与明細情報も全部削除してよろしいでしょうか?　なお、社員が退職状態になるなら、編集画面で在籍状況を“退職済“に変更してください。', 'ヒント', {
                  cancelButtonClass: "btn-custom-cancel",
                  confirmButtonClass: "btn-custom-confirm-a",
                  confirmButtonText: this.$t("general.confirm"),
                  cancelButtonText: this.$t("general.cancel"),
                  type: "warning",
                  customClass: "customClassStyle",
                  center: "true"
                })
                  .then(() => {
                    this.deleteSalaryAll(index, row);
                    this.handleDeleteNoHint(index, row);
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: this.$t("general.canceled")
                    });
                  });
              }
            }
          })
          .catch((error) => {
            this.$message.error('エラー1');
            console.log(error);
          });
      },
      handleToMoney() {
        if (this.ruleForm.salary_month != null && this.ruleForm.salary_month != "") {
          if (this.ruleForm.salary_month.indexOf(",") != -1) {
            this.ruleForm.salary_month = String(this.ruleForm.salary_month);
            this.ruleForm.salary_month = Number(this.ruleForm.salary_month.split(",").join(""));
          }
          this.ruleForm.salary_month = Number(this.ruleForm.salary_month).toLocaleString();
        }
      },
      changeTableSort(column) {
        this.sortName = column.prop;
        this.sortOrder = column.order;
        let postData = this.qs.stringify({
          sortName: this.sortName,
          sortOrder: this.sortOrder,
          page: this.currentPage
        });
        this.axios({
          method: "post",
          url: "/changeTableSort",
          data: postData,
        })
          .then((response) => {
            this.tableData = response.data;
            this.getPages();
          })
          .catch((error) => {
            console.log(error);
          });
        localStorage.setItem("sortName", JSON.stringify(this.sortName));
        localStorage.setItem("sortOrder", JSON.stringify(this.sortOrder));
      },
      handleSortChange() {
        let postData = this.qs.stringify({
          sortName: JSON.parse(localStorage.getItem("sortName")),
          sortOrder: JSON.parse(localStorage.getItem("sortOrder")),
          page: this.currentPage
        });
        this.axios({
          method: "post",
          url: "/changeTableSort",
          data: postData,
        })
          .then((response) => {
            this.tableData = response.data;
            this.getPages();
          })
          .catch((error) => {
            console.log(error);
          });
      },
      DateInput11(val) {
        this.JPDate(val);
        this.dateForm.DateInput11 = this.dateForm.JPDate;
      },
      DateInput12(val) {
        this.JPDateToEn(val);
        this.dateForm.DateInput12 = this.dateForm.JPDate;
      },
      JPDateToEn(val) {
        if (val === "") {
          this.dateForm.JPDate = "";
        }
        if (val.indexOf("/") != -1) {
          var tempDate = val.split("/");

          var JPYear = tempDate[0].substring(0, 1);
          var JPYearNum = tempDate[0].substring(1);
          var JPMonthNum = tempDate[1];
          var JPDayNum = tempDate[2];

          switch (JPYear) {
            case "S":
              JPYearNum = Number(JPYearNum) + 1925;
              JPMonthNum < 10 ? JPMonthNum = "0" + JPMonthNum : JPMonthNum;
              JPDayNum < 10 ? JPDayNum = "0" + JPDayNum : JPDayNum;
              break;
            case "H":
              JPYearNum = Number(JPYearNum) + 1988;
              JPMonthNum < 10 ? JPMonthNum = "0" + JPMonthNum : JPMonthNum;
              JPDayNum < 10 ? JPDayNum = "0" + JPDayNum : JPDayNum;
              break;
            case "R":
              JPYearNum = Number(JPYearNum) + 2018;
              JPMonthNum < 10 ? JPMonthNum = "0" + JPMonthNum : JPMonthNum;
              JPDayNum < 10 ? JPDayNum = "0" + JPDayNum : JPDayNum;
              break;
          }
          this.dateForm.JPDate = JPYearNum + "-" + JPMonthNum + "-" + JPDayNum;
        }
      },
      JPDate(val) {
        var date = new Date(val);
        var JPDate = new Intl.DateTimeFormat('ja-JP-u-ca-japanese').format(date);
        this.dateForm.JPDate = JPDate;
        if (val === null) {
          this.dateForm.JPDate = "";
        }

      },
      handleAddEmp(ruleForm) {
        let postData = this.qs.stringify({
          employee_id: this.ruleForm.employee_id
        });
        this.axios({
          method: "post",
          url: "/eidIsNotExisting",
          data: postData,
        })
          .then((resp) => {
            if (resp.status == 200) {
              var json = resp.data;
              if (json.status == "not") {
                this.addUser(ruleForm);
              } else if (json.status == "is") {
                this.$message.error('社員番号は既に存在しています。');
              }
            }
          })
          .catch((error) => {
            this.$message.error('エラー');
            console.log(error);
          });
      },
      handleUpdateEmp(ruleForm) {
        let postData = this.qs.stringify({
          employee_id: this.ruleForm.employee_id
        });
        if (this.ruleForm.employee_id === this.tableForm.employee_id) {
          this.updateUser(ruleForm);
        } else {
          this.axios({
            method: "post",
            url: "/eidIsNotExisting",
            data: postData,
          })
            .then((resp) => {
              if (resp.status == 200) {
                var json = resp.data;
                if (json.status == "not") {
                  this.updateUser(ruleForm);
                } else if (json.status == "is") {
                  this.$message.error('社員番号は既に存在しています。');
                }
              }
            })
            .catch((error) => {
              this.$message.error('エラー');
              console.log(error);
            });
        }
      },
      searchLocation(fidPostCode) {
        'use strict';
        /**
         * 郵便番号の変更イベント
         */
        // collaboflow.events.on('request.input.fidPostCode.change', function (eventData) {
        // 郵便番号を格納
        var postCode = fidPostCode.replace('-', '');
        if (postCode.length !== 7) {
          return;
        }
        var headers = {};
        var parseType = 'json';

        // 指定された郵便番号で住所を取得する
        // 郵便番号取得
        // https://api-doc.postcode-jp.com/#e0cee72981
        var apiKey = 'urbKBOFBWaFT7Xl5l8c2wQxnc6EqJHf6SkzZ5QC';
        var parameters = '?apiKey=' + apiKey;
        var url = 'https://apis.postcode-jp.com/api/v2/postcodes/' + postCode + parameters;

        this.axios({
          method: "get",
          url: url,
          headers: headers,
          parseType: parseType,
        })
          .then((response) => {

            if (response.status !== 200) {
              throw Error(response);
            }

            var searchResult = response.data;
            // 取得した住所の値を設定
            this.ruleForm.address1 = searchResult.allAddress;
            // this.addressForm.fidAddressHira = searchResult.allAddressFullHira;
            this.ruleForm.address_kn1 = searchResult.allAddressFullKana;
          })
          .catch(function (error) {
            // エラーリソース
            // https://api-doc.postcode-jp.com/#ec6399d678
            console.error(error);

            alert('住所の検索に失敗しました。自分入力してください！');
            return false;
          });
        // });
      },

      ExcelSample() {
        window.open("/pdfSample/employee_infomation_import_sample.xlsx");
      },
      //---------------------------------------------------------------------------------------------------
      //upload excel 
      // 上传文件之前的钩子：判断上传文件格式、大小等，若返回false则停止上传
      beforeUpload(file) {
        //文件类型
        const isType = file.type === 'application/vnd.ms-excel'
        const isTypeComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        const fileType = isType || isTypeComputer
        if (!fileType) {
          this.$message.error('「.xls」または「.xlsx」ファイルをアプロードしてください！')
        }

        // 文件大小限制为10M
        const fileLimit = file.size / 1024 / 1024 < 10;
        if (!fileLimit) {
          this.$message.error('ファイルサイズ10Mまでアプロードしてください！')
        }
        return fileType && fileLimit
      },
      // 自定义上传方法，param是默认参数，可以取得file文件信息，具体信息如下图
      uploadHttpRequest(param) {
        const formData = new FormData() //FormData对象，添加参数只能通过append('key', value)的形式添加
        formData.append('mfile', param.file) //添加文件对象
        formData.append('uploadType', this.rulesType)
        const url = "/uploadEmpInfo" //上传地址
        this.axios.post(url, formData)
          .then(res => {
            this.ruleForm.insertEmpCount = res.data[0];
            this.ruleForm.noInsertEmpCount = res.data[1];
            if (res.data[0] > 0 && res.data[1] === 0) {
              this.$message({
                type: "success",
                message: this.$t("取込完了しました。"),
              });
            }
            if (res.data[0] > 0 && res.data[1] > 0) {
              this.$message({
                type: "success",
                message: this.$t("一部データ取込完了しましたが、未取込データがあります。"),
              });
            }
            if (res.data[0] === 0 && res.data[1] > 0) {
              this.$message({
                type: "warning",
                message: this.$t("インポートされたデータはすでに登録しました。未登録データを選択してください。"),
              });
            }
            if (res.data[0] === 0 && res.data[1] === 0) {
              this.$message({
                type: "warning",
                message: this.$t("取込の時エラーができました。"),
              });
            }
            this.handleCurrentChange();
          })
          .catch(err => {
            this.$message({
              type: "warning",
              message: this.$t("取込できません。"),
            });
            param.onError() //上传失败的文件会从文件列表中删除
          })

      },
      // 点击上传：手动上传到服务器，此时会触发组件的http-request
      submitUpload() {
        this.$refs.upload.submit()
        this.$refs.upload.clearFiles() //清除上传文件对象
        this.fileList = [] //清空选择的文件列表
      },
      // 文件发生改变
      fileChange(file, fileList) {
        if (fileList.length > 0) {
          this.fileList = [fileList[fileList.length - 1]] // 展示最后一次选择的文件
        }
      },
      // 移除选择的文件
      fileRemove(file, fileList) {
        if (fileList.length < 1) {
          this.uploadDisabled = true //未选择文件则禁用上传按钮
        }
      },
      // 取消
      closeDialog() {
        this.$refs.upload.clearFiles() //清除上传文件对象
        this.fileList = [] //清空选择的文件列表
        this.$emit('close', false)
        this.dialogUploadExcel = false;
        this.ruleForm.insertEmpCount = "0",
          this.ruleForm.noInsertEmpCount = "0"
      },
      selectCountry(formData) {
        this.ruleForm.nation = formData;
      },
      doAdd() {
        this.addFamily = true;
      },
      printPDF(employee_id) {
        var arr = this.familyData;
        let postData = this.qs.stringify({
          employee_id: arr[0].employee_id,
        });

        this.axios({
          method: "post",
          url: "/FamilyPDF",
          data: postData,
        })
          .then((response) => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed"),
            });

          })
          .catch((error) => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed"),
            });
            console.log(error);
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
        this.accountType = false;
        this.tableForm.employee_id = this.ruleForm.employee_id;
        this.ruleForm.salary_month = Number(this.ruleForm.salary_month).toLocaleString();
      },
      familyEdit(index, row) {
        this.updateFamily = true;
        this.ruleFamily = Object.assign({}, row);
        this.ruleFamily.money_raise = Number(this.ruleFamily.money_raise).toLocaleString();
      },
      handleDetails(index, row) {
        this.dialogDetails = true;
        this.ruleForm = Object.assign({}, row);
        localStorage.setItem("employee_id", JSON.stringify(row.employee_id));
        this.uploadData.employee_id = JSON.parse(localStorage.getItem("employee_id"));
        // this.uploadData.employee_id = row.employee_id;
        this.ruleForm.salary_month = Number(this.ruleForm.salary_month).toLocaleString();
      },
      handleDetailsFromFamily(index, row) {
        this.dialogDetailsFromFamily = true;
        this.ruleFamily = Object.assign({}, row);
        localStorage.setItem("employee_id", JSON.stringify(row.employee_id));
        this.uploadData.employee_id = JSON.parse(
          localStorage.getItem("employee_id")
        );
      },

      handleFamily(index, row) {
        this.dialogFamily = true;
        this.ruleForm.name = row.name;
        this.eid = row.id;
        this.ruleForm.employee_id = row.employee_id;
        this.employee_id = row.employee_id;
        this.pageFamily();
      },
      handleDeleteNoHint(index, row) {
        let postData = this.qs.stringify({
          id: row.id,
        });
        this.axios({
          method: "post",
          url: "/deleteEmpList",
          data: postData,
        })
          .then((response) => {
            let postData = this.qs.stringify({
              sortName: JSON.parse(localStorage.getItem("sortName")),
              sortOrder: JSON.parse(localStorage.getItem("sortOrder")),
              page: this.currentPage
            });
            this.axios({
              method: "post",
              url: "/changeTableSort",
              data: postData,
            })
              .then((response) => {
                this.tableData = response.data;
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      },
      handleDelete(index, row) {
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning",
        })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id,
            });
            this.axios({
              method: "post",
              url: "/deleteEmpList",
              data: postData,
            })
              .then((response) => {
                let postData = this.qs.stringify({
                  sortName: JSON.parse(localStorage.getItem("sortName")),
                  sortOrder: JSON.parse(localStorage.getItem("sortOrder")),
                  page: this.currentPage
                });
                this.axios({
                  method: "post",
                  url: "/changeTableSort",
                  data: postData,
                })
                  .then((response) => {
                    this.tableData = response.data;
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                // this.getPages();
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });

              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled"),
            });
          });
      },
      handleFamilyDelete(index, row) {
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: "OK",
          cancelButtonText: this.$t("general.cancel"),
          type: "warning",
        })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id,
            });
            this.axios({
              method: "post",
              url: "/deleteFamily",
              data: postData,
            })
              .then((response) => {
                var result = response.data;
                if (result != 0) {
                  this.pageFamily();
                  this.$message({
                    type: "success",
                    message: this.$t("general.delete_completed"),
                  });
                } else {
                  this.$message({
                    type: "warning",
                    message: "エラーが発生しました",
                  });
                }
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled"),
            });
          });

      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning",
        })
          .then((_) => {
            done();
            this.emptyUserData();
            this.emptyFamilyData();
            this.$refs.ruleForm.resetFields();
          })
          .catch((_) => {

          });
        // this.$refs.ruleForm.resetFields();
      },
      handleCurrentChange() {

        let postData = this.qs.stringify({
          page: this.currentPage,
        });
        this.axios({
          method: "post",
          url: "/pageEmpList",
          data: postData,
        })
          .then((response) => {
            this.tableData = response.data;
          })
          .catch((error) => {
            console.log(error);
          });

        this.axios({
          method: "post",
          url: "/rowsEmpList",
          data: postData,
        })
          .then((response) => {
            this.total = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.dialogDetailsFromFamily = false;
        this.dialogFamily = false;
        this.dialogUploadExcel = false;
        this.emptyUserData();
        this.emptyFamilyData();
        this.$refs[ruleForm].resetFields();
      },

      //此处为什么要加/pageEmpList方法了？忘了。导致detail页面关闭bug
      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.dialogDetailsFromFamily = false;
        this.dialogFamily = false;
        this.emptyUserData();
        this.emptyFamilyData();
        let postData = this.qs.stringify({
          page: this.currentPage
        })
        this.axios({
          method: "post",
          url: "/changeTableSort",
          data: postData,
        })
          .then((response) => {
            this.tableData = response.data;
          })
          .catch((error) => {
          });
      },
      cancelFamily() {
        this.addFamily = false;
        this.updateFamily = false;
        this.dialogDetailsFromFamily = false;
        this.emptyFamilyData();
      },
      s1_cancelFamily(ruleFamily) {
        this.addFamily = false;
        this.updateFamily = false;
        this.dialogDetailsFromFamily = false;
        this.emptyFamilyData();
        this.$refs[ruleFamily].resetFields();
      },
      emptyUserData() {
        this.dateForm.JPDateType = false,
          this.dateForm.JPDate = "",
          this.dateForm.DateInput11 = "",
          this.dateForm.DateInput12 = "",
          this.ruleForm = {
            name: "",
            emp_img: "",
            employee_id: "",
            company_id: "",
            name_frgn: "",
            name_rm: "",
            post_code: "",
            birthday: "",
            gender: "",
            mynum: "",
            email: "",
            work_status: "",
            begin_date: "",
            end_date: "",
            cause: "",
            employee_type: "",
            title: "",
            work_content: "",
            address1: "",
            address2: "",
            address3: "",
            tel: "",
            bank_name: "",
            bank_name_frgn: "",
            bank_branch: "",
            bank_branch_frgn: "",
            bank_code: "",
            branch_code: "",
            deposit_type: "",
            account: "",
            account_name: "",
            emp_insuranceID: "",
            emp_ins_begin_day: "",
            emp_ins_end_day: "",
            pensionID: "",
            health_insuranceID: "",
            basic_pensionID: "",
            salary_changeday: "",
            salary_month: "",
            commuting_fee: "",
            nation: "",
            resident: "",
            resident_code: "",
            resident_date: "",
            dependent_number: "0",
            address_kn1: "",
            address_kn2: "",
            address_kn3: ""
          };
      },
      emptyFamilyData() {
        this.ruleFamily = {
          name_family: "",
          name_frgn_family: "",
          nation: "",
          gender: "",
          relation: "",
          mynum_family: "",
          birthday_family: "",
          income: 0,
          together: false,
          address: "",
          money_raise: 0,
          non_resident_is: false,
          withholding_d_is: false,
          raise_d_not: false,
          raise_division: "",
          disabled_division: "",
          cause: "",
          memo: "",
          date: ""
        };
      },
      addUser(ruleForm) {
        this.ruleForm.salary_month = String(this.ruleForm.salary_month);
        this.ruleForm.salary_month = Number(this.ruleForm.salary_month.split(",").join(""));
        if (this.ruleForm.birthday != null && this.ruleForm.birthday != "") {
          if (this.ruleForm.birthday.indexOf("/") != -1) {
            this.ruleForm.birthday = this.dateForm.JPDate;
          }
        }
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              company_id: this.company_id,
              name: this.ruleForm.name,
              name_frgn: this.ruleForm.name_frgn,
              name_rm: this.ruleForm.name_rm,
              post_code: this.ruleForm.post_code,
              mynum: this.ruleForm.mynum,
              employee_id: this.ruleForm.employee_id,
              birthday: this.ruleForm.birthday,
              gender: this.ruleForm.gender,
              email: this.ruleForm.email,
              work_status: this.ruleForm.work_status,
              begin_date: this.ruleForm.begin_date,
              end_date: this.ruleForm.end_date,
              cause: this.ruleForm.cause,
              employee_type: this.ruleForm.employee_type,
              title: this.ruleForm.title,
              work_content: this.ruleForm.work_content,
              address1: this.ruleForm.address1,
              address2: this.ruleForm.address2,
              address3: this.ruleForm.address3,
              tel: this.ruleForm.tel,
              bank_name: this.ruleForm.bank_name,
              bank_name_frgn: this.ruleForm.bank_name_frgn,
              bank_branch: this.ruleForm.bank_branch,
              bank_branch_frgn: this.ruleForm.bank_branch_frgn,
              bank_code: this.ruleForm.bank_code,
              branch_code: this.ruleForm.branch_code,
              deposit_type: this.ruleForm.deposit_type,
              account: this.ruleForm.account,
              account_name: this.ruleForm.account_name,
              emp_insuranceID: this.ruleForm.emp_insuranceID,
              emp_ins_begin_day: this.ruleForm.emp_ins_begin_day,
              emp_ins_end_day: this.ruleForm.emp_ins_end_day,
              pensionID: this.ruleForm.pensionID,
              health_insuranceID: this.ruleForm.health_insuranceID,
              basic_pensionID: this.ruleForm.basic_pensionID,
              salary_changeday: this.ruleForm.salary_changeday,
              salary_month: this.ruleForm.salary_month,
              commuting_fee: this.ruleForm.commuting_fee,
              nation: this.ruleForm.nation,
              resident: this.ruleForm.resident,
              licenses: this.ruleForm.licenses,
              resident_code: this.ruleForm.resident_code,
              resident_date: this.ruleForm.resident_date,
              dependent_number: this.ruleForm.dependent_number,
              address_kn1: this.ruleForm.address_kn1,
              address_kn2: this.ruleForm.address_kn2,
              address_kn3: this.ruleForm.address_kn3
            });
            this.axios({
              method: "post",
              url: "/insertEmpList",
              data: postData,
            })
              .then((response) => {
                let postData = this.qs.stringify({
                  sortName: JSON.parse(localStorage.getItem("sortName")),
                  sortOrder: JSON.parse(localStorage.getItem("sortOrder")),
                });
                this.axios({
                  method: "post",
                  url: "/changeTableSort",
                  data: postData,
                })
                  .then((response) => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.s1_cancel(ruleForm);
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed"),
                    });
                  })
                  .catch((error) => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed"),
                    });
                    console.log(error);
                  });
                this.getPages();
                this.s1_cancel();
                // this.dialogVisible = false;

              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message.error("必須項目が入力されていません");
            return false;
          }
        });
      },
      AddFamily(ruleFamily) {
        this.ruleFamily.income = Number(String(this.ruleFamily.income).split(",").join(""));
        this.ruleFamily.money_raise = Number(String(this.ruleFamily.money_raise).split(",").join(""));
        if (this.ruleFamily.birthday_family != null && this.ruleFamily.birthday_family != "") {
          if (this.ruleFamily.birthday_family.indexOf("/") != -1) {
            this.ruleFamily.birthday_family = this.dateForm.JPDate;
          }
        }
        this.$refs[ruleFamily].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              eid: this.eid,
              name_family: this.ruleFamily.name_family,
              name_frgn_family: this.ruleFamily.name_frgn_family,
              nation: this.ruleFamily.nation,
              gender: this.ruleFamily.gender,
              relation: this.ruleFamily.relation,
              mynum_family: this.ruleFamily.mynum_family,
              birthday_family: this.ruleFamily.birthday_family,
              income: this.ruleFamily.income,
              together: this.ruleFamily.together,
              address: this.ruleFamily.address,
              money_raise: this.ruleFamily.money_raise,
              non_resident_is: this.ruleFamily.non_resident_is,
              withholding_d_is: this.ruleFamily.withholding_d_is,
              raise_d_not: this.ruleFamily.raise_d_not,
              raise_division: this.ruleFamily.raise_division,
              disabled_division: this.ruleFamily.disabled_division,
              cause: this.ruleFamily.cause,
              memo: this.ruleFamily.memo,
            });
            this.axios({
              method: "post",
              url: "/insertFamily",
              data: postData,
            })
              .then((response) => {
                if (response.data > 0) {
                  this.pageFamily();
                  this.$message({
                    type: "success",
                    message: this.$t("general.add_completed"),
                  });
                  this.emptyFamilyData();
                  this.addFamily = false;
                } else {
                  this.$message({
                    type: "warning",
                    message: this.$t("general.add_failed"),
                  });
                }
              })
              .catch((error) => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.add_failed"),
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message.error('必須項目が入力されていません');
            return false;
          }
        });
      },
      EditFamily(ruleFamily) {
        this.ruleFamily.income = Number(String(this.ruleFamily.income).split(",").join(""));
        this.ruleFamily.money_raise = Number(String(this.ruleFamily.money_raise).split(",").join(""));
        if (this.ruleFamily.birthday_family != null && this.ruleFamily.birthday_family != "") {
          if (this.ruleFamily.birthday_family.indexOf("/") != -1) {
            this.ruleFamily.birthday_family = this.dateForm.JPDate;
          }
        }
        this.$refs[ruleFamily].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleFamily.id,
              eid: this.eid,
              name_family: this.ruleFamily.name_family,
              name_frgn_family: this.ruleFamily.name_frgn_family,
              nation: this.ruleFamily.nation,
              gender: this.ruleFamily.gender,
              relation: this.ruleFamily.relation,
              mynum_family: this.ruleFamily.mynum_family,
              birthday_family: this.ruleFamily.birthday_family,
              income: this.ruleFamily.income,
              together: (this.ruleFamily.together === null ? false : this.ruleFamily.together),
              address: this.ruleFamily.address,
              money_raise: this.ruleFamily.money_raise,
              non_resident_is: (this.ruleFamily.non_resident_is === null ? false : this.ruleFamily.non_resident_is),
              withholding_d_is: (this.ruleFamily.withholding_d_is === null ? false : this.ruleFamily.withholding_d_is),
              raise_d_not: (this.ruleFamily.raise_d_not === null ? false : this.ruleFamily.raise_d_not),
              raise_division: this.ruleFamily.raise_division,
              disabled_division: this.ruleFamily.disabled_division,
              cause: this.ruleFamily.cause,
              memo: this.ruleFamily.memo,
            });
            this.axios({
              method: "post",
              url: "/updateFamily",
              data: postData,
            })
              .then((response) => {
                if (response.data > 0) {
                  this.pageFamily();
                  this.$message({
                    type: "success",
                    message: this.$t("general.edit_completed"),
                  });
                  this.emptyFamilyData();
                  this.updateFamily = false;
                } else {
                  this.$message({
                    type: "warning",
                    message: this.$t("general.edit_failed"),
                  });
                }
              })
              .catch((error) => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed"),
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message.error('必須項目が入力されていません');
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.ruleForm.salary_month = String(this.ruleForm.salary_month);
        this.ruleForm.salary_month = Number(this.ruleForm.salary_month.split(",").join(""));
        if (this.ruleForm.birthday != null && this.ruleForm.birthday != "") {
          if (this.ruleForm.birthday.indexOf("/") != -1) {
            this.ruleForm.birthday = this.dateForm.JPDate;
          }
        }
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              company_id: this.company_id,
              employee_id: this.ruleForm.employee_id,
              name: this.ruleForm.name,
              name_frgn: this.ruleForm.name_frgn,
              name_rm: this.ruleForm.name_rm,
              post_code: this.ruleForm.post_code,
              birthday: this.ruleForm.birthday,
              gender: this.ruleForm.gender,
              email: this.ruleForm.email,
              mynum: this.ruleForm.mynum,
              work_status: this.ruleForm.work_status,
              begin_date: this.ruleForm.begin_date,
              end_date: this.ruleForm.end_date,
              cause: this.ruleForm.cause,
              employee_type: this.ruleForm.employee_type,
              title: this.ruleForm.title,
              work_content: this.ruleForm.work_content,
              address1: this.ruleForm.address1,
              address2: this.ruleForm.address2,
              address3: this.ruleForm.address3,
              tel: this.ruleForm.tel,
              bank_name: this.ruleForm.bank_name,
              bank_name_frgn: this.ruleForm.bank_name_frgn,
              bank_branch: this.ruleForm.bank_branch,
              bank_branch_frgn: this.ruleForm.bank_branch_frgn,
              bank_code: this.ruleForm.bank_code,
              branch_code: this.ruleForm.branch_code,
              deposit_type: this.ruleForm.deposit_type,
              account: this.ruleForm.account,
              account_name: this.ruleForm.account_name,
              emp_insuranceID: this.ruleForm.emp_insuranceID,
              emp_ins_begin_day: this.ruleForm.emp_ins_begin_day,
              emp_ins_end_day: this.ruleForm.emp_ins_end_day,
              pensionID: this.ruleForm.pensionID,
              health_insuranceID: this.ruleForm.health_insuranceID,
              basic_pensionID: this.ruleForm.basic_pensionID,
              salary_changeday: this.ruleForm.salary_changeday,
              salary_month: this.ruleForm.salary_month,
              commuting_fee: this.ruleForm.commuting_fee,
              nation: this.ruleForm.nation,
              resident: this.ruleForm.resident,
              licenses: this.ruleForm.licenses,
              resident_code: this.ruleForm.resident_code,
              resident_date: this.ruleForm.resident_date,
              dependent_number: this.ruleForm.dependent_number,
              address_kn1: this.ruleForm.address_kn1,
              address_kn2: this.ruleForm.address_kn2,
              address_kn3: this.ruleForm.address_kn3
            });
            this.axios({
              method: "post",
              url: "/updateEmpList",
              data: postData,
            })
              .then((response) => {
                this.handleSortChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed"),
                });
                let postData = this.qs.stringify({
                });
              })
              .catch((error) => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed"),
                });
                console.log(error);
              });
          } else {

            this.$message.error("必須項目が入力されていません");
            return false;
          }
        });
      },
      onSearch() {
        let postData = this.qs.stringify({
          name: this.search,
        });
        this.axios({
          method: "post",
          url: "/ListByNameEmpList",
          data: postData,
        })
          .then((response) => {
            this.tableData = response.data;
            this.disablePage = true;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      getPages() {
        this.axios
          .post("/rowsEmpList")
          .then((response) => {
            this.total = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      },
      handleAvatarSuccess(res, file) {
        this.ruleForm.emp_img = URL.createObjectURL(file.raw);
        this.$message({
          type: "success",
          message: this.$t("general.uploadCompleted"),
        });
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === "image/jpeg";
        const isLt1M = file.size / 1024 / 1024 < 1;

        if (!isJPG) {
          this.$message.error("ユーザー画像はJPG形式である必要があります！");
        }
        if (!isLt1M) {
          this.$message.error(
            "ユーザー画像サイズは1MBを超えることはできません！"
          );
        }
        return isJPG && isLt1M;
      },
    },
    created() {
      this.axios
        .post("/pageComInfo")
        .then((response) => {
          this.company_id = response.data[0].id;
        })
        .catch((error) => {

        });
      this.axios
        .post("/pageEmpList")
        .then((response) => {

          this.tableData = response.data;
        })
        .catch((error) => {
        });
      this.axios
        .post("/rowsEmpList")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
        });
    },
    data() {
      return {
        eid: "",
        employee_id: "",
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
        uploadData: {
          employee_id: 123,
        },
        show: false,
        labelPosition: "left",
        activeNames: ['1', '2', '3', '4', '5'],
        activeNamesFamily: ['1'],
        residents: [{
          residentsId: 0,
          name: this.$t("empList.none"),
        },
        {
          residentsId: 1,
          name: this.$t("empList.r1"),
        },
        {
          residentsId: 2,
          name: this.$t("empList.r2"),
        },
        {
          residentsId: 3,
          name: this.$t("empList.r3"),
        },
        {
          residentsId: 4,
          name: this.$t("empList.r4"),
        },
        {
          residentsId: 5,
          name: this.$t("empList.r5"),
        },
        {
          residentsId: 6,
          name: this.$t("empList.r6"),
        },
        {
          residentsId: 7,
          name: this.$t("empList.r7"),
        },
        {
          residentsId: 8,
          name: this.$t("empList.r8"),
        },
        {
          residentsId: 9,
          name: this.$t("empList.r9"),
        },
        {
          residentsId: 10,
          name: this.$t("empList.r10"),
        },
        {
          residentsId: 11,
          name: this.$t("empList.r11"),
        },
        {
          residentsId: 12,
          name: this.$t("empList.r12"),
        },
        {
          residentsId: 13,
          name: this.$t("empList.r13"),
        },
        {
          residentsId: 14,
          name: this.$t("empList.r14"),
        },
        {
          residentsId: 15,
          name: this.$t("empList.r15"),
        },
        {
          residentsId: 16,
          name: this.$t("empList.r16"),
        },
        {
          residentsId: 17,
          name: this.$t("empList.r17"),
        },
        {
          residentsId: 18,
          name: this.$t("empList.r18"),
        },
        {
          residentsId: 19,
          name: this.$t("empList.r19"),
        },
        {
          residentsId: 20,
          name: this.$t("empList.r20"),
        },
        {
          residentsId: 21,
          name: this.$t("empList.r21"),
        },
        {
          residentsId: 22,
          name: this.$t("empList.r22"),
        },
        {
          residentsId: 23,
          name: this.$t("empList.r23"),
        },
        {
          residentsId: 24,
          name: this.$t("empList.r24"),
        },
        {
          residentsId: 25,
          name: this.$t("empList.r25"),
        },
        {
          residentsId: 26,
          name: this.$t("empList.r26"),
        },
        {
          residentsId: 27,
          name: this.$t("empList.r27"),
        },
        {
          residentsId: 28,
          name: this.$t("empList.r28"),
        },
        {
          residentsId: 29,
          name: this.$t("empList.r29"),
        },
        {
          residentsId: 30,
          name: this.$t("empList.r30"),
        },
        {
          residentsId: 31,
          name: this.$t("empList.r31"),
        },
        ],
        status: [{
          statusId: 1,
          name: this.$t("empList.in_office"),
        },
        {
          statusId: 2,
          name: this.$t("empList.on_leave"),
        },
        {
          statusId: 3,
          name: this.$t("empList.retired"),
        },
        ],


        country: [
          {
            label: "Popular country",
            options: [
              { value: "日本", label: "Japan" },
            ]
          },
          {
            label: "All country",
            options: [
              { value: "アブハジア", label: "Abkhazia, Republic of" },
              { value: "アフガニスタン", label: "Afghanistan" },
              { value: "アルバニア", label: "Albania" },
              { value: "アルジェリア", label: "Algeria" },
              { value: "アンドラ", label: "Andorra" },
              { value: "アンゴラ", label: "Angola" },
              { value: "アンティグア・バーブーダ", label: "Antigua and Barbuda" },
              { value: "アルゼンチン", label: "Argentina" },
              { value: "アルメニア", label: "Armenia" },
              { value: "オーストラリア", label: "Australia" },
              { value: "オーストリア", label: "Austria" },
              { value: "アゼルバイジャン", label: "Azerbaijan" },
              { value: "バハマ", label: "Bahamas" },
              { value: "バーレーン", label: "Bahrain" },
              { value: "バングラデシュ", label: "Bangladesh" },
              { value: "バルバドス", label: "Barbados" },
              { value: "ベラルーシ", label: "Belarus" },
              { value: "ベルギー", label: "Belgium" },
              { value: "ベリーズ", label: "Belize" },
              { value: "ベナン", label: "Benin" },
              { value: "ブータン", label: "Bhutan" },
              { value: "ボリビア", label: "Bolivia, Plurinational State of" },
              { value: "ボスニア・ヘルツェゴビナ", label: "Bosnia and Herzegovina" },
              { value: "ボツワナ", label: "Botswana" },
              { value: "ブラジル", label: "Brazil" },
              { value: "ブルネイ", label: "Brunei Darussalam" },
              { value: "ブルガリア", label: "Bulgaria" },
              { value: "ブルキナファソ", label: "Burkina Faso" },
              { value: "ブルンジ", label: "Burundi" },
              { value: "カンボジア", label: "Cambodia" },
              { value: "カメルーン", label: "Cameroon" },
              { value: "カナダ", label: "Canada" },
              { value: "カーボベルデ", label: "Cape Verde" },
              { value: "中央アフリカ共和国", label: "Central African Republic" },
              { value: "チャド", label: "Chad" },
              { value: "チリ", label: "Chile" },
              { value: "中国", label: "China" },
              { value: "コロンビア", label: "Colombia" },
              { value: "コモロ", label: "Comoros" },
              { value: "コンゴ共和国", label: "Congo" },
              { value: "コンゴ民主共和国", label: "Congo, the Democratic Republic of the" },
              { value: "クック諸島", label: "Cook Islands" },
              { value: "コスタリカ", label: "Costa Rica" },
              { value: "コートジボワール", label: "Côte d'Ivoire" },
              { value: "クロアチア", label: "Croatia" },
              { value: "キューバ", label: "Cuba" },
              { value: "キプロス", label: "Cyprus" },
              { value: "チェコ", label: "Czechia" },
              { value: "デンマーク", label: "Denmark" },
              { value: "ジブチ", label: "Djibouti" },
              { value: "ドミニカ国", label: "Dominica" },
              { value: "ドミニカ共和国", label: "Dominican Republic" },
              { value: "エクアドル", label: "Ecuador" },
              { value: "エジプト", label: "Egypt" },
              { value: "エルサルバドル", label: "El Salvador" },
              { value: "赤道ギニア", label: "Equatorial Guinea" },
              { value: "エリトリア", label: "Eritrea" },
              { value: "エストニア", label: "Estonia" },
              { value: "エチオピア", label: "Ethiopia" },
              { value: "フィジー", label: "Fiji" },
              { value: "フィンランド", label: "Finland" },
              { value: "フランス", label: "France" },
              { value: "ガボン", label: "Gabon" },
              { value: "ガンビア", label: "Gambia" },
              { value: "ジョージア", label: "Georgia" },
              { value: "ドイツ", label: "Germany" },
              { value: "ガーナ", label: "Ghana" },
              { value: "ギリシャ", label: "Greece" },
              { value: "グレナダ", label: "Grenada" },
              { value: "グアテマラ", label: "Guatemala" },
              { value: "ギニア", label: "Guinea" },
              { value: "ギニアビサウ", label: "Guinea-Bissau" },
              { value: "ガイアナ", label: "Guyana" },
              { value: "ハイチ", label: "Haiti" },
              { value: "バチカン", label: "Holy See (Vatican City State)" },
              { value: "ホンジュラス", label: "Honduras" },
              { value: "ハンガリー", label: "Hungary" },
              { value: "アイスランド", label: "Iceland" },
              { value: "インド", label: "India" },
              { value: "インドネシア", label: "Indonesia" },
              { value: "イラン", label: "Iran, Islamic Republic of" },
              { value: "イラク", label: "Iraq" },
              { value: "アイルランド", label: "Ireland" },
              { value: "イスラエル", label: "Israel" },
              { value: "イタリア", label: "Italy" },
              { value: "ジャマイカ", label: "Jamaica" },
              { value: "日本", label: "Japan" },
              { value: "ヨルダン", label: "Jordan" },
              { value: "カザフスタン", label: "Kazakhstan" },
              { value: "ケニア", label: "Kenya" },
              { value: "キリバス", label: "Kiribati" },
              { value: "北朝鮮", label: "Korea, Democratic People's Republic of" },
              { value: "韓国", label: "Korea, Republic of" },
              { value: "コソボ", label: "Kosovo" },
              { value: "クウェート", label: "Kuwait" },
              { value: "キルギス", label: "Kyrgyzstan" },
              { value: "ラオス", label: "Lao People's Democratic Republic" },
              { value: "ラトビア", label: "Latvia" },
              { value: "レバノン", label: "Lebanon" },
              { value: "レソト", label: "Lesotho" },
              { value: "リベリア", label: "Liberia" },
              { value: "リビア", label: "Libya" },
              { value: "リヒテンシュタイン", label: "Liechtenstein" },
              { value: "リトアニア", label: "Lithuania" },
              { value: "ルクセンブルク", label: "Luxembourg" },
              { value: "マケドニア旧ユーゴスラビア共和国", label: "Macedonia, the former Yugoslav Republic" },
              { value: "マダガスカル", label: "Madagascar" },
              { value: "マラウイ", label: "Malawi" },
              { value: "マレーシア", label: "Malaysia" },
              { value: "モルディブ", label: "Maldives" },
              { value: "マリ", label: "Mali" },
              { value: "マルタ", label: "Malta" },
              { value: "マーシャル諸島", label: "Marshall Islands" },
              { value: "モーリタニア", label: "Mauritania" },
              { value: "モーリシャス", label: "Mauritius" },
              { value: "メキシコ", label: "Mexico" },
              { value: "ミクロネシア連邦", label: "Micronesia, Federated States of" },
              { value: "モルドバ", label: "Moldova, Republic of" },
              { value: "モナコ", label: "Monaco" },
              { value: "モンゴル", label: "Mongolia" },
              { value: "モンテネグロ", label: "Montenegro" },
              { value: "モロッコ", label: "Morocco" },
              { value: "モザンビーク", label: "Mozambique" },
              { value: "ミャンマー", label: "Myanmar" },
              { value: "ナゴルノ・カラバフ", label: "Nagorno Karabagh Republic" },
              { value: "ナミビア", label: "Namibia" },
              { value: "ナウル", label: "Nauru" },
              { value: "ネパール", label: "Nepal" },
              { value: "オランダ", label: "Netherlands" },
              { value: "ニュージーランド", label: "New Zealand" },
              { value: "ニカラグア", label: "Nicaragua" },
              { value: "ニジェール", label: "Niger" },
              { value: "ナイジェリア", label: "Nigeria" },
              { value: "ニウエ", label: "Niue" },
              { value: "北キプロス", label: "Northern Cyprus" },
              { value: "ノルウェー", label: "Norway" },
              { value: "オマーン", label: "Oman" },
              { value: "パキスタン", label: "Pakistan" },
              { value: "パラオ", label: "Palau" },
              { value: "パレスチナ", label: "Palestinian Territory, Occupied" },
              { value: "パナマ", label: "Panama" },
              { value: "パプアニューギニア", label: "Papua New Guinea" },
              { value: "パラグアイ", label: "Paraguay" },
              { value: "ペルー", label: "Peru" },
              { value: "フィリピン", label: "Philippines" },
              { value: "ポーランド", label: "Poland" },
              { value: "ポルトガル", label: "Portugal" },
              { value: "沿ドニエストル", label: "Pridnestrovian Moldavian Republic" },
              { value: "カタール", label: "Qatar" },
              { value: "ルーマニア", label: "Romania" },
              { value: "ロシア", label: "Russian Federation" },
              { value: "ルワンダ", label: "Rwanda" },
              { value: "セントクリストファー・ネイビス", label: "Saint Kitts and Nevis" },
              { value: "セントルシア", label: "Saint Lucia" },
              { value: "セントビンセントおよびグレナディーン諸島", label: "Saint Vincent and the Grenadines" },
              { value: "サモア", label: "Samoa" },
              { value: "サンマリノ", label: "San Marino" },
              { value: "サントメ・プリンシペ", label: "Sao Tome and Principe" },
              { value: "サウジアラビア", label: "Saudi Arabia" },
              { value: "セネガル", label: "Senegal" },
              { value: "セルビア", label: "Serbia" },
              { value: "セーシェル", label: "Seychelles" },
              { value: "シエラレオネ", label: "Sierra Leone" },
              { value: "シンガポール", label: "Singapore" },
              { value: "スロバキア", label: "Slovakia" },
              { value: "スロベニア", label: "Slovenia" },
              { value: "ソロモン諸島", label: "Solomon Islands" },
              { value: "ソマリア", label: "Somalia" },
              { value: "ソマリランド", label: "Somaliland, Republic of" },
              { value: "南アフリカ", label: "South Africa" },
              { value: "南オセチア", label: "South Ossetia" },
              { value: "南スーダン", label: "South Sudan" },
              { value: "スペイン", label: "Spain" },
              { value: "スリランカ", label: "Sri Lanka" },
              { value: "スーダン", label: "Sudan" },
              { value: "スリナム", label: "Suriname" },
              { value: "スワジランド", label: "Swaziland" },
              { value: "スウェーデン", label: "Sweden" },
              { value: "スイス", label: "Switzerland" },
              { value: "シリア", label: "Syrian Arab Republic" },
              { value: "台湾", label: "Taiwan, Province of China" },
              { value: "タジキスタン", label: "Tajikistan" },
              { value: "タンザニア", label: "Tanzania, United Republic of" },
              { value: "タイ", label: "Thailand" },
              { value: "東ティモール", label: "Timor-Leste" },
              { value: "トーゴ", label: "Togo" },
              { value: "トンガ", label: "Tonga" },
              { value: "トリニダード・トバゴ", label: "Trinidad and Tobago" },
              { value: "チュニジア", label: "Tunisia" },
              { value: "トルコ", label: "Turkey" },
              { value: "トルクメニスタン", label: "Turkmenistan" },
              { value: "ツバル", label: "Tuvalu" },
              { value: "ウガンダ", label: "Uganda" },
              { value: "ウクライナ", label: "Ukraine" },
              { value: "アラブ首長国連邦", label: "United Arab Emirates" },
              { value: "イギリス", label: "United Kingdom" },
              { value: "アメリカ", label: "United States" },
              { value: "ウルグアイ", label: "Uruguay" },
              { value: "ウズベキスタン", label: "Uzbekistan" },
              { value: "バヌアツ", label: "Vanuatu" },
              { value: "ベネズエラ", label: "Venezuela, Bolivarian Republic of" },
              { value: "ベトナム", label: "Viet Nam" },
              { value: "西サハラ", label: "Western Sahara" },
              { value: "イエメン", label: "Yemen" },
              { value: "ザンビア", label: "Zambia" },
              { value: "ジンバブエ", label: "Zimbabwe" },
            ]
          }
        ],
        options: [{
          value: '同居老親等',
          label: '同居老親等'
        }, {
          value: '特定扶養親族',
          label: '特定扶養親族'
        }, {
          value: 'その他',
          label: 'その他'
        }],
        options2: [{
          value: '障害者',
          label: '障害者'
        }, {
          value: '特別障害者',
          label: '特別障害者'
        }, {
          value: '同居特別障害者',
          label: '同居特別障害者'
        },],
        relations: [{
          relationsId: 1,
          name: this.$t("empList.wife"),
        },
        {
          relationsId: 2,
          name: this.$t("empList.husband"),
        },
        {
          relationsId: 3,
          name: this.$t("empList.mother"),
        },
        {
          relationsId: 4,
          name: this.$t("empList.father"),
        },
        {
          relationsId: 5,
          name: this.$t("empList.mother_in_law"),
        },
        {
          relationsId: 6,
          name: this.$t("empList.father_in_law"),
        },
        {
          relationsId: 7,
          name: this.$t("empList.eldest_son"),
        },
        {
          relationsId: 8,
          name: this.$t("empList.eldest_daughter"),
        },
        {
          relationsId: 9,
          name: this.$t("empList.second_son"),
        },
        {
          relationsId: 10,
          name: this.$t("empList.second_daughter"),
        },
        {
          relationsId: 11,
          name: this.$t("empList.elder_brother"),
        },
        {
          relationsId: 12,
          name: this.$t("empList.elder_sister"),
        },
        {
          relationsId: 13,
          name: this.$t("empList.younger_brother"),
        },
        {
          relationsId: 14,
          name: this.$t("empList.younger_sister"),
        },
        {
          relationsId: 15,
          name: this.$t("empList.grandfather"),
        },
        {
          relationsId: 16,
          name: this.$t("empList.grandmother"),
        },
        ],
        social_status: [{
          social_statusId: 1,
          name: this.$t("empList.dont_support"),
        },
        {
          social_statusId: 2,
          name: this.$t("empList.support"),
        },
        {
          social_statusId: 3,
          name: this.$t("empList.not_sure"),
        },
        ],
        employee_types: [
          {
            employee_type_id: 1,
            name: "役員（雇用保険未加入）",
          },
          {
            employee_type_id: 2,
            name: "役員（雇用保険加入）",
          },
          {
            employee_type_id: 3,
            name: this.$t("empList.permanent"),
          },
          {
            employee_type_id: 4,
            name: this.$t("empList.contract"),
          },
          {
            employee_type_id: 5,
            name: this.$t("empList.temporary"),
          },
          {
            employee_type_id: 6,
            name: this.$t("empList.part_time"),
          },
          {
            employee_type_id: 7,
            name: this.$t("general.other"),
          },
        ],
        deposit_types: [{
          deposit_types_id: 1,
          name: this.$t("empList.deposit"),
        },
        {
          deposit_types_id: 2,
          name: this.$t("empList.checking"),
        },
        {
          deposit_types_id: 3,
          name: this.$t("empList.savings"),
        },
        ],
        licenses: [
          {
            label: "有 ",
            value: "有 ",
          },
          {
            label: "無",
            value: "無",
          },
        ],
        dependent_number: [
          {
            label: "甲欄の扶養親族0人",
            value: "0",
          },
          {
            label: "甲欄の扶養親族1人",
            value: "1",
          },
          {
            label: "甲欄の扶養親族2人",
            value: "2",
          },
          {
            label: "甲欄の扶養親族3人",
            value: "3",
          },
          {
            label: "甲欄の扶養親族4人",
            value: "4",
          },
          {
            label: "甲欄の扶養親族5人",
            value: "5",
          },
          {
            label: "甲欄の扶養親族6人",
            value: "6",
          },
          {
            label: "甲欄の扶養親族7人",
            value: "7",
          },
          {
            label: "乙欄",
            value: "B",
          },
        ],

        dateForm: {
          JPDateType: false,
          JPDate: "",
          DateInput11: "",
          DateInput12: "",
          DateInput21: "",
          DateInput22: "",
        },
        ruleForm: {
          id: "",
          emp_img: "",
          company_id: "",
          employee_id: "",
          name: "",
          name_rm: "",
          name_frgn: "",
          post_code: "",
          birthday: "",
          birthday: "",
          gender: "",
          email: "",
          mynum: "",
          work_status: "",
          begin_date: "",
          end_date: "",
          cause: "",
          employee_type: "",
          title: "",
          work_content: "",
          address1: "",
          address2: "",
          address3: "",
          address_kn1: "",
          address_kn2: "",
          address_kn3: "",
          tel: "",
          bank_name: "",
          bank_name_frgn: "",
          bank_branch: "",
          bank_branch_frgn: "",
          bank_code: "",
          branch_code: "",
          deposit_type: "",
          account: "",
          account_name: "",
          emp_insuranceID: "",
          emp_ins_begin_day: "",
          emp_ins_end_day: "",
          pensionID: "",
          health_insuranceID: "",
          basic_pensionID: "",
          salary_changeday: "",
          salary_month: "",
          commuting_fee: "",
          nation: "",
          resident: "",
          licenses: "",
          resident_code: "",
          resident_date: "",
          dependent_number: "0",
          insertEmpCount: "0",
          noInsertEmpCount: "0",
        },
        tableForm: {
          employee_id: ""
        },
        ruleFamily: {
          id: "",
          eid: "",
          name_family: "",
          name_frgn_family: "",
          nation: "",
          gender: "",
          relation: "",
          mynum_family: "",
          birthday_family: "",
          income: 0,
          together: false,
          address: "",
          money_raise: 0,
          non_resident_is: false,
          withholding_d_is: false,
          raise_d_not: false,
          raise_division: "",
          disabled_division: "",
          cause: "",
          memo: "",
          date: ""
        },
        rules: {
          dependent_number: [{
            required: true,
            message: "選択してください",
            trigger: "blur",
          },],
          name: [{
            required: true,
            message: this.$t("empList.nameRule"),
            trigger: "blur",
          },
          {
            pattern: /^[^\\x00-\\xff|\\uff61-\\uff9f|A-Za-z0-9)]+$/,
            message: this.$t("全角で入力してください"),
          },
            // { min: 2, max: 7, message: "长度在 2 到 7 个字符", trigger: "blur" }
          ],
          birthday: [{
            required: true,
            message: this.$t("empList.birthdayP"),
            trigger: "blur",
          },],
          gender: [{
            required: true,
            message: this.$t("empList.gender_rule"),
            trigger: "blur",
          },],
          name_family: [{
            required: true,
            message: this.$t("empList.fill"),
            trigger: "blur",
          },],
          // birthday_family: [{
          //   required: true,
          //   message: this.$t("empList.fill"),
          //   trigger: "blur",
          // },],
          // name_frgn_family: [{
          //   required: true,
          //   message: this.$t("empList.fill"),
          //   trigger: "blur",
          // },],
          // nation_family: [{
          //   required: true,
          //   message: this.$t("empList.fill"),
          //   trigger: "blur",
          // },],
          work_status: [{
            required: true,
            message: this.$t("empList.work_statusRule"),
            trigger: "blur",
          },],
          begin_date: [{
            required: true,
            message: this.$t("empList.begin_dateRule"),
            trigger: "blur",
          },],
          employee_type: [{
            required: true,
            message: this.$t("empList.employee_typeRule"),
            trigger: "blur",
          },],
          post_code: [
            {
              pattern: /^(?:|\d{3}-\d{4})$/,
              message: this.$t("companyInfo.filltel"),
            },
          ],
          tel: [{
            required: true,
            message: this.$t("empList.telRule"),
            trigger: "blur",
          },
          {
            pattern: /^(?:|\d{3}-\d{3}-\d{4}|\d{4}-\d{2}-\d{4}|\d{2}-\d{4}-\d{4}|\d{3}-\d{4}-\d{4})$/,
            message: this.$t("companyInfo.filltel"),
          },
          ],
          salary_changeday: [{
            required: true,
            message: this.$t("empList.fill"),
            trigger: "blur",
          },],
          salary_month: [{
            required: true,
            message: this.$t("empList.fill"),
            trigger: "blur",
          },],
          commuting_fee: [{
            required: true,
            message: this.$t("empList.fill"),
            trigger: "blur",
          },],
          // email: [{
          //   required: true,
          //   message: this.$t("empList.emailRule"),
          //   trigger: "blur",
          // },
          // {
          //   pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          //   message: this.$t("register.emailPattern"),
          // },
          // ],
          name_frgn: [
            {
              required: true,
              message: this.$t("empList.name_fnRule"),
              trigger: "blur",
            },
            {
              pattern: /^[^\\x00-\\xff|\\uff61-\\uff9f|A-Za-z0-9)]+$/,
              message: this.$t("全角で入力してください"),
            },
          ],
          nation: [{
            required: true,
            message: this.$t("empList.nation_rule"),
            trigger: "blur",
          },],
          employee_id: [
            {
              required: true,
              message: this.$t("empList.employee_idP"),
              trigger: "blur",
            },
            {
              pattern: /^[A-Za-z0-9_]+$/,
              message: this.$t("社員番号は半角英数字を入力してください。"),
            },
          ],
        },
        familyData: [],
        tableData: [],
        search: "",
        addFamily: false,
        updateFamily: false,
        dialogVisible: false,
        dialogUpdate: false,
        dialogDetails: false,
        dialogDetailsFromFamily: false,
        dialogFamily: false,
        dialogUploadExcel: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false,
        sortName: "",
        sortOrder: "",
        company_id: "",
        accountType: false
      };
    },
  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }

  .btn-custom-confirm-a {
    width: 90px;
    margin-right: -200px;
  }

  .customClassStyle {
    width: 450px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .el-icon-delete {
    visibility: hidden;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }

  .style1 {
    margin-right: 124px;
    padding: 0px;
    text-align: right;
  }

  .style6 {
    margin-top: 30px;
    padding: 0px;
  }

  .style2 {
    margin-right: 15px;
    padding: 0px;
    text-align: right;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .label-style {
    margin-left: 30px;
    margin-right: 50px;
    font-style: normal;
    font-weight: normal;
    font-size: xx-large;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    padding: 0px;
  }

  /* .label {
  font-weight: bold;
} */
</style>


// WEBPACK FOOTER //
// src/components/EmpList.vue